
/**
*
*
* @module globalJS
*
*/

/**
*
*
* @class Plugins
*
*/



// TWC recode global JS

// Stop-gap variable assignment
// ----------------------------
// On the UK site there is a check done on the backend
// "In a vb file for a the site default master page" - Jay Halai

window.mobile = false; // NOTE: this needs to be checked and created on the backend WURFL where are you?

/*  Start Hacking the transition enviroment (Hybris)
    NOTE: window.console.log assignment has been put in to catch any stray
    console.log() calls that are not inside JS files that will be minified (and thus purged of these calls)
    notable example is as inline JS at JSP of tag level.
*/

if ( !window.console )
{
    window.console = { log : function() { return; } };
}

/* End Hacking */

// third party javascript

/*!
 * hoverIntent r7 // 2013.03.11 // jQuery 1.9.1+
 * http://cherne.net/brian/resources/jquery.hoverIntent.html
 *
 * You may use hoverIntent under the terms of the MIT license.
 * Copyright 2007, 2013 Brian Cherne
 */

 /**
 *
 * Jquery plugin http://cherne.net/brian/resources/jquery.hoverIntent.html
 * @method hoverIntent
 */
(function(e){e.fn.hoverIntent=function(t,n,r){var i={interval:100,sensitivity:7,timeout:0};if(typeof t==="object"){i=e.extend(i,t)}else if(e.isFunction(n)){i=e.extend(i,{over:t,out:n,selector:r})}else{i=e.extend(i,{over:t,out:t,selector:n})}var s,o,u,a;var f=function(e){s=e.pageX;o=e.pageY};var l=function(t,n){n.hoverIntent_t=clearTimeout(n.hoverIntent_t);if(Math.abs(u-s)+Math.abs(a-o)<i.sensitivity){e(n).off("mousemove.hoverIntent",f);n.hoverIntent_s=1;return i.over.apply(n,[t])}else{u=s;a=o;n.hoverIntent_t=setTimeout(function(){l(t,n)},i.interval)}};var c=function(e,t){t.hoverIntent_t=clearTimeout(t.hoverIntent_t);t.hoverIntent_s=0;return i.out.apply(t,[e])};var h=function(t){var n=jQuery.extend({},t);var r=this;if(r.hoverIntent_t){r.hoverIntent_t=clearTimeout(r.hoverIntent_t)}if(t.type=="mouseenter"){u=n.pageX;a=n.pageY;e(r).on("mousemove.hoverIntent",f);if(r.hoverIntent_s!=1){r.hoverIntent_t=setTimeout(function(){l(n,r)},i.interval)}}else{e(r).off("mousemove.hoverIntent",f);if(r.hoverIntent_s==1){r.hoverIntent_t=setTimeout(function(){c(n,r)},i.timeout)}}};return this.on({"mouseenter.hoverIntent":h,"mouseleave.hoverIntent":h},i.selector)}})(jQuery);

/**
 *
 * Jquery plugin http://swipejs.com Single Element View swipe carousel
 * @method Swipe
 */

/** Single Element View swipe carousel **/
function Swipe(e,t){"use strict";function h(){o=s.children;f=o.length;if(o.length<2)t.continuous=false;if(i.transitions&&t.continuous&&o.length<3){s.appendChild(o[0].cloneNode(true));s.appendChild(s.children[1].cloneNode(true));o=s.children}u=new Array(o.length);a=e.getBoundingClientRect().width||e.offsetWidth;s.style.width=o.length*a+"px";var n=o.length;while(n--){var r=o[n];r.style.width=a+"px";r.setAttribute("data-index",n);if(i.transitions){r.style.left=n*-a+"px";g(n,l>n?-a:l<n?a:0,0)}}if(t.continuous&&i.transitions){g(v(l-1),-a,0);g(v(l+1),a,0)}if(!i.transitions)s.style.left=l*-a+"px";e.style.visibility="visible"}function p(){if(t.continuous)m(l-1);else if(l)m(l-1)}function d(){if(t.continuous)m(l+1);else if(l<o.length-1)m(l+1)}function v(e){return(o.length+e%o.length)%o.length}function m(e,n){if(l==e)return;if(i.transitions){var s=Math.abs(l-e)/(l-e);if(t.continuous){var f=s;s=-u[v(e)]/a;if(s!==f)e=-s*o.length+e}var h=Math.abs(l-e)-1;while(h--)g(v((e>l?e:l)-h-1),a*s,0);e=v(e);g(l,a*s,n||c);g(e,0,n||c);if(t.continuous)g(v(e-s),-(a*s),0)}else{e=v(e);b(l*-a,e*-a,n||c)}l=e;r(t.callback&&t.callback(l,o[l]))}function g(e,t,n){y(e,t,n);u[e]=t}function y(e,t,n){var r=o[e];var i=r&&r.style;if(!i)return;i.webkitTransitionDuration=i.MozTransitionDuration=i.msTransitionDuration=i.OTransitionDuration=i.transitionDuration=n+"ms";i.webkitTransform="translate("+t+"px,0)"+"translateZ(0)";i.msTransform=i.MozTransform=i.OTransform="translateX("+t+"px)"}function b(e,n,r){if(!r){s.style.left=n+"px";return}var i=+(new Date);var u=setInterval(function(){var a=+(new Date)-i;if(a>r){s.style.left=n+"px";if(w)S();t.transitionEnd&&t.transitionEnd.call(event,l,o[l]);clearInterval(u);return}s.style.left=(n-e)*(Math.floor(a/r*100)/100)+e+"px"},4)}function S(){E=setTimeout(d,w)}function x(){w=0;clearTimeout(E)}var n=function(){};var r=function(e){setTimeout(e||n,0)};var i={addEventListener:!!window.addEventListener,touch:"ontouchstart"in window||window.DocumentTouch&&document instanceof DocumentTouch,transitions:function(e){var t=["transitionProperty","WebkitTransition","MozTransition","OTransition","msTransition"];for(var n in t)if(e.style[t[n]]!==undefined)return true;return false}(document.createElement("swipe"))};if(!e)return;var s=e.children[0];var o,u,a,f;t=t||{};var l=parseInt(t.startSlide,10)||0;var c=t.speed||300;t.continuous=t.continuous!==undefined?t.continuous:true;var w=t.auto||0;var E;var T={};var N={};var C;var k={handleEvent:function(e){switch(e.type){case"touchstart":this.start(e);break;case"touchmove":this.move(e);break;case"touchend":r(this.end(e));break;case"webkitTransitionEnd":case"msTransitionEnd":case"oTransitionEnd":case"otransitionend":case"transitionend":r(this.transitionEnd(e));break;case"resize":r(h.call());break}if(t.stopPropagation)e.stopPropagation()},start:function(e){var t=e.touches[0];T={x:t.pageX,y:t.pageY,time:+(new Date)};C=undefined;N={};s.addEventListener("touchmove",this,false);s.addEventListener("touchend",this,false)},move:function(e){if(e.touches.length>1||e.scale&&e.scale!==1)return;if(t.disableScroll)e.preventDefault();var n=e.touches[0];N={x:n.pageX-T.x,y:n.pageY-T.y};if(typeof C=="undefined"){C=!!(C||Math.abs(N.x)<Math.abs(N.y))}if(!C){e.preventDefault();x();if(t.continuous){y(v(l-1),N.x+u[v(l-1)],0);y(l,N.x+u[l],0);y(v(l+1),N.x+u[v(l+1)],0)}else{N.x=N.x/(!l&&N.x>0||l==o.length-1&&N.x<0?Math.abs(N.x)/a+1:1);y(l-1,N.x+u[l-1],0);y(l,N.x+u[l],0);y(l+1,N.x+u[l+1],0)}}},end:function(e){var n=+(new Date)-T.time;var r=Number(n)<250&&Math.abs(N.x)>20||Math.abs(N.x)>a/2;var i=!l&&N.x>0||l==o.length-1&&N.x<0;if(t.continuous)i=false;var f=N.x<0;if(!C){if(r&&!i){if(f){if(t.continuous){g(v(l-1),-a,0);g(v(l+2),a,0)}else{g(l-1,-a,0)}g(l,u[l]-a,c);g(v(l+1),u[v(l+1)]-a,c);l=v(l+1)}else{if(t.continuous){g(v(l+1),a,0);g(v(l-2),-a,0)}else{g(l+1,a,0)}g(l,u[l]+a,c);g(v(l-1),u[v(l-1)]+a,c);l=v(l-1)}t.callback&&t.callback(l,o[l])}else{if(t.continuous){g(v(l-1),-a,c);g(l,0,c);g(v(l+1),a,c)}else{g(l-1,-a,c);g(l,0,c);g(l+1,a,c)}}}s.removeEventListener("touchmove",k,false);s.removeEventListener("touchend",k,false)},transitionEnd:function(e){if(parseInt(e.target.getAttribute("data-index"),10)==l){if(w)S();t.transitionEnd&&t.transitionEnd.call(e,l,o[l])}}};h();if(w)S();if(i.addEventListener){if(i.touch)s.addEventListener("touchstart",k,false);if(i.transitions){s.addEventListener("webkitTransitionEnd",k,false);s.addEventListener("msTransitionEnd",k,false);s.addEventListener("oTransitionEnd",k,false);s.addEventListener("otransitionend",k,false);s.addEventListener("transitionend",k,false)}window.addEventListener("resize",k,false)}else{window.onresize=function(){h()}}return{setup:function(){h()},slide:function(e,t){x();m(e,t)},prev:function(){x();p()},next:function(){x();d()},getPos:function(){return l},getNumSlides:function(){return f},kill:function(){x();s.style.width="auto";s.style.left=0;var e=o.length;while(e--){var t=o[e];t.style.width="100%";t.style.left=0;if(i.transitions)y(e,0,0)}if(i.addEventListener){s.removeEventListener("touchstart",k,false);s.removeEventListener("webkitTransitionEnd",k,false);s.removeEventListener("msTransitionEnd",k,false);s.removeEventListener("oTransitionEnd",k,false);s.removeEventListener("otransitionend",k,false);s.removeEventListener("transitionend",k,false);window.removeEventListener("resize",k,false)}else{window.onresize=null}}}}if(window.jQuery||window.Zepto){(function(e){e.fn.Swipe=function(t){return this.each(function(){e(this).data("Swipe",new Swipe(e(this)[0],t))})}})(window.jQuery||window.Zepto)}



/**
* Amplience DPW inplementation, its called by amplience when a shop now button in amplience is clicked on.
* @tencmsInvokeAction
* @param {String} data - sku code for product
* @param {} unused
* @param {} unused
* @for window
*/

/* Amplience - DPW implementation */

/*
Note: Original UK implementation, now defunct
function tencmsInvokeAction(data,areaID,context){
    if(data){
        if( data.indexOf("GOTOSCREEN") == 0 ){
        // We should go to a specific screen
        var parts = data.split("_");
            if( parts.length == 2){
            var screentogoto = Number(parts[1]);
                if( window.amplienceGoToScreen ){
                window.amplienceGoToScreen( screentogoto );
                }
            }
        } else if (data.indexOf("#") == 0) {
            twc.cms.aniScroll(data);
        } else {
        twc.cms.getHotspotData(data, false);
        }
    }
} */

tencmsInvokeAction = function( data, areaID, context ) {
//  Presently data is the product SKU
    twc.events.onAmplienceQuickViewRequest( data );
}

/**
*
* Custom written jquery plugin
*   Usage
*       $('.info').axHandler({
*           'requestType'      : 'get',
*           'responseDataType' : 'html'
*       });
* @method axHandler
* @param {String} requestType - either get/post
* @param {String} responseDataType - html/json
* @for Plugins
*/

/**
*
* Usage
*
*   $('.info').axHandler({
*       'requestType'      : 'get',
*       'responseDataType' : 'html'
*   });
*
*/

;(function ( $, window, document, undefined ) {

    // Create the defaults once
    var pluginName = "axHandler";
        /*defaults = {
            'requestType'       : 'get',
            'responseDataType'  : 'html',
            'class'             : 'standard-popup'
        };*/

    // The actual plugin constructor
    function Plugin( element, options ) {
        this.element = element;

        var $popupLink = $(this.element);

        this.settings = {

            'requestType'       :  $popupLink.attr("data-requestType")      || 'get',
            'responseDataType'  :  $popupLink.attr("data-responseDataType") || 'html',
            'elClass'           :  $popupLink.attr("data-class")            || 'default-popup',
            'tooltip'           :  $popupLink.attr("data-tooltip")          || false
        }

        this.settings = $.extend( this.settings, options );
        //this.options = $.extend( {}, defaults, options) ;
        //this._defaults = defaults;
        this._name = pluginName;

        this.init();
    }

    Plugin.prototype = {

        init: function() {

            this.popupContentDiv = this.createDisplayDiv(this.settings);
            this.$requestContent = $(this.popupContentDiv).children(".request-content");
            this.$contentDiv     = $(this.popupContentDiv);

            this.bindEvents();
        },

        createDisplayDiv: function() {

            // create the popup container, close button, and requets content wrapper
            var  axContentDiv = document.createElement("div"),
                 closeButton  = document.createElement("img"),
                 axContent    = document.createElement("div");

            // add classes to the created dom elements
            $(axContentDiv).addClass("standard-popup");
            $(axContentDiv).addClass(this.settings.elClass);
            axContent.className = "request-content";

            $(closeButton).attr({
                src    : '/_ui/desktop/theme-twc/images/xbutton.gif', // TODO!!! Change this file reference (or add it in this path)
                width  : 25,
                height : 25
            });

            //build the dom up

            axContentDiv.appendChild(closeButton);
            axContentDiv.appendChild(axContent);

            // add close click handler to the close button

            $(closeButton).on("click",function () {
                $(".standard-popup:visible").fadeOut('fast');
                //possibly change the text of the size guide
            });

            // add the new div to the DOM
            if (this.settings.tooltip) {
                this.element.appendChild(axContentDiv);
            } else if ( this.settings.$parent ) {
            //  NOTE: included for transition to allow us to push the content into a .uk-legacy parent
                this.settings.$parent.append(axContentDiv);
            } else {
                document.getElementById('page').appendChild(axContentDiv);
            }

            return axContentDiv;

        },

        doAjax: function(clickedLink) {

            var _self = this;

            // send ajax request
            $.ajax({
                // Content to retrieve
                url: clickedLink.attr("data-popup"),

                // Request type
                type: _self.settings.reqestType,

                // Data return type of response
                dataType: _self.settings.responseDataType,

                error: function(){
                    // Load the content in to the page.
                    _self.$requestContent.html("<p>Content Not Found!</p>");

                },

                beforeSend: function(){
                    // show loading sign?
                },

                complete: function(){
                    _self.$contentDiv.fadeIn('fast');
                },

                success: function(strData){

                    // Load the content in to the page.
                    _self.$requestContent[0].innerHTML = strData;
                }
            }); // end ajax

        },

        bindEvents: function () {

            var _self = this;

            if (this.settings.tooltip) {
                // bind hover event
                $(this.element).on("mouseover", function(event) {

                    // only do request if the relevant popup is not showing
                    if ( !$(".standard-popup:visible").hasClass($(this).attr("data-class")) ) {
                        $(".standard-popup:visible").stop().fadeOut('fast');
                        _self.doAjax($(this));
                    }
                });

                $(this.$contentDiv).on("mouseleave", function(event){
                    $(".standard-popup:visible").stop().fadeOut('fast');
                });

                $(this.element).on("click", function(event) {
                    event.preventDefault();
                });

            } else {
                // bind click event

                $(this.element).on("click", function(event) {

                    _self.doAjax($(this));

                    event.preventDefault();

                });


            }

        }

    }

    $.fn[pluginName] = function ( options ) {
        return this.each(function () {
            if (!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName,
                new Plugin( this, options ));
            }
        });
    };

})( jQuery, window, document );

// namespace for whitecompany javascript

var project = "twc";

// Project namespace
window[project] = window[project] || { _onReady: [] };

window[project].on_load = { _onLoad: [] };

/**
* Use of autoload function
* Create a init object assigned to project:
* twc.init = {methods and properties for functions that need to be run on every page}
* Addd onload functions by: adding the a literal containing functions to run onload to the autoload array.
* literal must be bound to the project namespace
* twc._autoload.push('init');
**/

/**
* Douglous Crockford <http://javascript.crockford.com/prototypal.html>
* Prototypal inheritance support for ECMA Script < 5
*/

if (typeof Object.create !== 'function') {
    Object.create = function (o) {
        function F() { }
        F.prototype = o;
        return new F();
    };
}

$(document).ready(function () {

       //loop through our array and call methods to run onload
        /*
        *twc._autoload.push('global'); where global is literal with onload functions
        *
        */

      for (var i = 0; i < window[project]._onReady.length; i++) {
        for (var method in window[project][window[project]._onReady[i]]) {
            if (typeof window[project][window[project]._onReady[i]][method] == 'function') {
                window[project][window[project]._onReady[i]][method]();
            }
        }
    }

});

// loop through on load functtions

$(window).on("load", function () {

     //loop through our array and call methods to run onload
        /*
        *twc._autoload.push('global'); where global is literal with onload functions
        *
        */

      for (var i = 0; i < window[project].on_load._onLoad.length; i++) {
        for (var method in window[project][window[project].on_load._onLoad[i]]) {
            if (typeof window[project][window[project].on_load._onLoad[i]][method] == 'function') {
                window[project][window[project].on_load._onLoad[i]][method]();
            }
        }
    }

});

/***

    On load Usage

twc.intialisGlobalOnload = {

    testOnload: function () {


    },

    testOnload2: function () {


    }

}

twc.on_load._onLoad.push("intialisGlobalOnload");


***/


/*
** Usage - supports
*
* if ( supports('transition') ) {
*
* }else{
*
*/

/**
* Tests support for css property, checks native and vendor prefixed support
* @method supports
* @for window
* @param {String} prop - css property to be tested
*/

var supports = (function () {
    var div = document.createElement('div'),
      vendors = ['Khtml', 'ms', 'O', 'Moz', 'Webkit'],
      len = vendors.length;

    return function (prop) {
        if (prop in div.style) return true;

        prop = prop.replace(/^[a-z]/, function (val) {
            return val.toUpperCase();
        });

        while (len--) {
            if (vendors[len] + prop in div.style) {
                // browser supports box-shadow. Do what you need.
                // Or use a bang (!) to test if the browser doesn't.
                return true;
            }
        }
        return false;
    };
})();


/**
*
*
* Utilities object which contains some useful event functions
* @class utils
*
*/



/*
*
* Usage - utils
*
* utils.addListener(object, 'eventtype', function);
* utils.getStyle(object, 'width')
*/
var utils = {
    addListener: null,
    removeListener: null,
    getStyle: null,

    /**
    * Wait for all images passed into the function to load before calling the callback
    * @method waitForAllImages
    * @param {Object} $images - jquery object of images
    * @param {Function} callback - function to call on successful load of images
    */

    waitForAllImages: function($images,callback) {
          //Keep track of the images that are loaded
          var imagesLoaded = 0;
          function loadAllImages(callback){
              //Create an temp image and load the url
              var img = new Image();
              $(img).attr('src', $images.eq(imagesLoaded).attr("src"));
              if (img.complete || img.readyState === 4) {
                  // image is cached
                  imagesLoaded++;
                  //Check if all images are loaded
                  if(imagesLoaded == $images.length) {
                      //If all images loaded do the callback
                      if (typeof callback === typeof Function) {
                          callback();
                      }
                  } else {
                      //If not all images are loaded call own function again
                      loadAllImages(callback);
                  }
              } else {
                  $(img).load(function(){
                      //Increment the images loaded variable
                      imagesLoaded++;
                      //Check if all images are loaded
                      if(imagesLoaded == $images.length) {
                          //If all images loaded do the callback
                          if (typeof callback === typeof Function) {
                              callback();
                          }
                      } else {
                          //If not all images are loaded call own function again
                          loadAllImages(callback);
                      }
                  });
              }
          }

      loadAllImages(callback);

    },

    /**
    * This takes an id as string or an element of native javascript and returns it is a jQuery Object
    * @method waitForAllImages
    * @param {Object} elmnt - Either string of jQuery object passed
    * @return {Object} returns jquery element
    */

    getAsJquery : function (elmnt) {
        var el_to_return;

        if ((typeof elmnt === typeof $("#page")) && (typeof elmnt.fadeOut === typeof Function)) {   // a JQuery object has been passed
            // console.log("JQuery object was passed");
            el_to_return = elmnt;

            return el_to_return;
        }
        else if ((typeof elmnt === typeof document.getElementById("page")) || (typeof elmnt === typeof "string")) {
            // console.log("getElementById or String used");
            // verify the element is usable
            if (typeof $(elmnt).fadeOut === typeof Function) {
                el_to_return = $(elmnt);

                return el_to_return;
            }
        }
        else {
            // no suitable elements provided
            // console.log("Unable to get as JQuery");
            return null;
        }
    },

    /**
    * Find and return a value query parameter from a url
    * @method getQueryParam
    * @param {String} key - value to search for in the url
    * @return {String} value - the value assinged to the key in the url
    */

    getQueryParam : function (key) {
        var query = location.search,
            end_val = undefined;

        if (query.indexOf(key) !== -1) {
            // check to see if there are any other query string attrs
            if (query.indexOf("&") !== -1) {
                if (query.indexOf("&", query.indexOf(key)) !== -1) {
                    end_val = query.indexOf("&", query.indexOf(key));
                    var value = query.substring(query.indexOf(key) + (key.length + 1), end_val);
                }
                else {
                    var value = query.substring(query.indexOf(key) + (key.length + 1));
                }
            }
            else {
                var value = query.substring(query.indexOf(key) + (key.length + 1));
            }

            return value;
        }
    }
};

// the implementation
if (typeof window.addEventListener === 'function') {

    /**
    * Wrapper for addEventListener to make it cross browser
    * @method addListener
    * @param {Object} el - value to search for in the url
    * @param {String} type - type of event click, change etc...
    * @param {Function} fn - event handler function
    */

    utils.addListener = function (el, type, fn) {
        el.addEventListener(type, fn, false);
    };

    /**
    * Wrapper for removeEventListener to make it cross browser
    * @method removeListener
    * @param {Object} el - value to search for in the url
    * @param {String} type - type of event click, change etc...
    * @param {Function} fn - event handler function
    */

    utils.removeListener = function (el, type, fn) {
        el.removeEventListener(type, fn, false);
    };
} else if (typeof document.attachEvent === 'function') { // IE

    /**
    * Find and return a value query parameter from a url
    * @method getQueryParam
    * @param {String} key - value to search for in the url
    * @return {String} value - the value assinged to the key in the url
    */
    utils.addListener = function (el, type, fn) {
        el.attachEvent('on' + type, fn);
    };
    utils.removeListener = function (el, type, fn) {
        el.detachEvent('on' + type, fn);
    };
} else { // older browsers
    utils.addListener = function (el, type, fn) {
        el['on' + type] = fn;
    };
    utils.removeListener = function (el, type, fn) {
        el['on' + type] = null;
    };
}

    /**
    * Wrapper for getComputedStyle to make it cross browser
    * @method getStyle
    * @param {Object} obj - DOM element
    * @param {String} prop - the style property
    * @return {} style that is requested i.e height
    */

if (!window.getComputedStyle) {
    utils.getStyle = function (obj, prop) {
        return parseInt(obj.currentStyle[prop], 10);
    };
} else {
    utils.getStyle = function (obj, prop) {
        return parseInt(window.getComputedStyle(obj, null).getPropertyValue(prop), 10);
    };
}


    /**
    * Capture the event when using Event delegation cross browser
    * @method getEvent
    * @param {Event} e - event object
    * @param {Object} what - DOM element that you want event captured for
    * @return {Object} the element the event was captured on
    * @for window
    */


/* getEvent function may be replaces with utils above */
function getEvent(e,what) { // e=event, what='target'/'type'

    var e=e || window.event;    // W3C/Netscape or IE event

    // if looking for target of event
    if (what.toLowerCase()==="target") {
        var target=e.target || e.srcElement;
        if (target.nodeType==3) {   // safari known issue - if target is a text node...
            target = target.parentNode; // gets the text node parent
        }
        return target;  // return the event target
    }

    // if looking for event type
    else if (what.toLowerCase()==="type") {
        return e.type;
    }

    // if no 'what' parameter specified
    else {
        return null;    // terminate
    }
}


    /**
    * Defines isMobile variable by using screen size and user Agent sniffing
    * @method isMobile
    * @return {Boolean}
    * @for window
    */

/* Simple mobile detection
*
* iPad detection excluded
*
*/
var isMobile = (function () {
    var tablet = (function () {
        if ( (screen.width > 767 && screen.height > 1023) || (screen.width > 1023 && screen.height > 767) ) {
            return true;
        } else {
            return false;
        }
    }());

    if ( navigator.userAgent.match(/Android/i)
    || navigator.userAgent.match(/webOS/i)
    || navigator.userAgent.match(/iPhone/i)
    || navigator.userAgent.match(/iPod/i)
    || navigator.userAgent.match(/BlackBerry/i)
    || navigator.userAgent.match(/Windows Phone/i)
    ) {
        if (!tablet) {
            return true;
        } else {
            return false;
        }

    } else {

        return false;
    }

})();

/**** End of Cross browser utility functions *****/

/*
* Function to change the context a function is being called in to overriede the value of 'this'*
* for ECMA script < 5
*e.g. this.init().bind(this);
* https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Function/bind
*/

if (!Function.prototype.bind) {
    Function.prototype.bind = function (oThis) {
        if (typeof this !== "function") {
            // closest thing possible to the ECMAScript 5 internal IsCallable function
            throw new TypeError("Function.prototype.bind - what is trying to be bound is not callable");
        }

        var aArgs = Array.prototype.slice.call(arguments, 1),
        fToBind = this,
        fNOP = function () { },
        fBound = function () {
            return fToBind.apply(this instanceof fNOP
                                 ? this
                                 : oThis,
                               aArgs.concat(Array.prototype.slice.call(arguments)));
        };

        fNOP.prototype = this.prototype;
        fBound.prototype = new fNOP();

        return fBound;
    };
}

// globals needed for Scene7 in the CMS module
var imagesets = [],
    imagset = [],
    imagset_test = [],
    altImageURL = [];


/**
*
* Amplience cms module - for use for all functionality used on CMS managed pages to show purchase window etc.
* @class cms
*
*/

twc.cms = (function () {
    var
        dpw_config = true,  // config variable to switch DPW functionality on or off : false = OFF, true = ON

        amplienceFns,

        /* Image viewing functionality */
        imageSelector = function () {
            var $img_viewer = $("#main-img"),
                //$first_alt    = document.getElementById("first-alt-img"),
                //$second_alt   = document.getElementById("second-alt-img"),
                current_img = null,
                img_clicked = null,
                clicked_pos = null,
                zoom_param      = "$Zoom1392x1392$",
                alt_img_preset  = "$Thumb163x163$",
                main_img_preset = "$Main326x326$";

            // get current main img
            current_img = $img_viewer.attr("src");

            // get the clicked img
            clicked_pos = this;

            // get this img SRC
            img_clicked = clicked_pos.src;

            // make this the new main img
            $img_viewer.attr("src", img_clicked.replace(alt_img_preset, main_img_preset));

            // put the current main img in place of the one clicked
            $(clicked_pos).attr("src", current_img.replace(main_img_preset, alt_img_preset));

                // figure out the right size version


            // need to figure out which alt it was - because this will influence the direction the images will 'rotate' in...

            // if alt 1 was clicked - then...
                // if (clicked_pos == "first-alt-img") {
//                  // the alt 1 image needs to move to the main pos
//
//              }
                // the alt 1 image needs to move to the main pos
                // the current main img needs to move to alt 2 pos...
                // the alt 2 needs to move to alt 1 pos...

            // if alt 2 is clicked
                // the alt 2 image needs to move to the main pos
                // the current main img needs to move to alt 1 pos...
                // the alt 1 needs to move to alt 2 pos...
        },

        /* Collapsible box component - eventually to be used across the site */
        collapsingBoxes2 = function (elmnts, options) {
            // variables
            var settings = options || {},
                details_boxes = elmnts, // get all boxes that are flagged as collapsible boxes
                no_of_boxes = details_boxes.length,
                i,
                tmp_widget,
                widget = document.createElement("span"),
                closedClass = ( !settings.isCheckout ) ? "collapse2-closed": "closed";

                // private methods
                openOrClose = (function (box) {

                    var prev_open_box   = null,
                        box_to_open     = box;

                    return function (box_to_open) {

                        $(box_to_open).children("div").slideToggle("slow", function () {
                            if ( !settings.isCheckout ) {
                                $(this).parent().addClass("collapse2-open").removeClass(closedClass);
                            }
                            else {
                                if ($(this).css("display") === "none") {
                                    $(box_to_open).addClass("closed");
                                }
                                else {
                                    $(box_to_open).removeClass("closed");
                                }
                            }
                        });

                        if (
                            prev_open_box && 
                            (prev_open_box !== box_to_open) && 
                            (box_to_open.getAttribute("data-closeothers") === "true") && 
                            ($(prev_open_box).children("div").css("display") != "none") 
                            )
                        {
                            $(prev_open_box).children("div").slideToggle("slow", function () {
                                $(this).parent().addClass(closedClass).removeClass("collapse2-open");
                            });
                        }

                        if (
                            prev_open_box !== box_to_open && 
                            $(box_to_open).attr("data-closeothers")
                            )
                        {
                            prev_open_box = box_to_open;
                        }
                    }
                }()),

                addWidgetListener = function (box_to_work_on) {
                    $(this).click( function () {
                        openOrClose.call(this, box_to_work_on);
                    });
                };  // end var

            // function body
            if (no_of_boxes > 0) {

                for (i = 0; i < no_of_boxes; i++) {

                    var $box = $(details_boxes[i]);
                    tmp_widget = widget.cloneNode(true);
                    tmp_widget.className = "widget"; // TODO: move this to the original span node creation

                    addWidgetListener.call(tmp_widget, details_boxes[i]); // NOTE: details boxes is not being used
                    $box.children("span").append(tmp_widget);

                    if ($box.attr("data-initialclosed")) {

                        $box.children("div").toggle();
                        if (settings.isCheckout) {
                            $box.addClass("closed");
                        }

                    }
                //  Might need to be conditional !isCheckout
                    if (
                        // !settings.isCheckout &&
                        !$box.attr("data-initialclosed") && 
                        details_boxes[i].getAttribute("data-closeothers") === "true"
                        ) 
                    {
                        $box.children("div").toggle();
                        tmp_widget.click();
                        $box.addClass("collapse2-open");
                    }
                }
            }
        },

        // initialise pop up function
        initDPWPopUp = function () {
            var blackout = (function () {
                    var blackout_div    = document.createElement("div");

                    blackout_div.setAttribute("id", "product-purchase-window-container");
                    $(blackout_div).css("display", "none");
                    $(blackout_div).width($(window).width());
                    $(blackout_div).height($(window).height());

                    $(window).on("resize", function () {
                        $(blackout_div).width($(window).width());
                        $(blackout_div).height($(window).height());
                    });

                    return blackout_div;
                }()),

                purchase_window_DOM = (function () {
                    var container       = document.createElement("div"),
                        close_button    = document.createElement("span");
                    // end var

                    // init

                    container.setAttribute("id", "product-purchase-window");

                    close_button.setAttribute("id", "window-purchase-close");

                    close_button.appendChild(document.createTextNode("close"));

                    container.appendChild(close_button);

                    return container;
                }()),

                image_container_DOM = (function () {
                    var outer_container             = document.createElement("div"),
                        main_img_container          = document.createElement("div"),
                        main_img                    = document.createElement("img"),
                        //first_alt_img_container       = document.createElement("div"),
                        //first_alt_img             = document.createElement("img"),
                        //second_alt_img_container  = document.createElement("div"),
                        //second_alt_img                = document.createElement("img")
                        alt_imgs_container          = document.createElement("div"),
                        alt_imgs_list               = document.createElement("ul");
                    // end var

                    // init

                    // setup image viewer container
                    outer_container.setAttribute("id", "window-purchase-imagecontainer");

                    // setup the main image
                    main_img_container.setAttribute("id", "window-purchase-mainimg");

                    main_img.setAttribute("id", "main-img");
                    main_img.setAttribute("src", "");
                    main_img.setAttribute("alt", "");
                    main_img.setAttribute("width", "326");      // not good???
                    main_img.setAttribute("height", "326");     // not good???

                    main_img_container.appendChild(main_img);

                    outer_container.appendChild(main_img_container);

                    $(alt_imgs_container).attr("id", "alt-imgs-container");
                    if (mobile && isMobile) {
                        $(alt_imgs_container).addClass("swipe");
                    }

                    $(alt_imgs_list).attr("id", "alt-imgs-list");
                    if (mobile && isMobile) {
                        $(alt_imgs_list).addClass("swipe-wrap");
                    }

                    $(alt_imgs_container).append(alt_imgs_list);

                    $(outer_container).append(alt_imgs_container);

                    $(alt_imgs_container).append(alt_imgs_list);

                    /*
                    // setup the first alternative img
                    // $(first_alt_img_container).addClass("inline-block f-left window-purchase-alt-img");
                    first_alt_img_container.setAttribute("id", "first-alt-image-container");

                    first_alt_img.setAttribute("id", "first-alt-img");
                    first_alt_img.setAttribute("src", "")
                    first_alt_img.setAttribute("alt", "");
                    first_alt_img.setAttribute("width", "163");
                    first_alt_img.setAttribute("height", "163");

                    first_alt_img_container.appendChild(first_alt_img);

                    outer_container.appendChild(first_alt_img_container);

                    // setup the second alternative image
                    //$(second_alt_img_container).addClass("inline-block f-left window-purchase-alt-img");
                    second_alt_img_container.setAttribute("id", "second-alt-image-container");

                    second_alt_img.setAttribute("id", "second-alt-img");
                    second_alt_img.setAttribute("src", "");
                    second_alt_img.setAttribute("alt", "");
                    second_alt_img.setAttribute("width", "163");
                    second_alt_img.setAttribute("height", "163");

                    second_alt_img_container.appendChild(second_alt_img);

                    outer_container.appendChild(second_alt_img_container);
                    */

                    return outer_container;
                }()),

                product_info_DOM = (function () {
                    var prod_info_container     = document.createElement("div"),
                        prod_price              = document.createElement("h2");
                    // end var

                    // init

                    prod_info_container.setAttribute("id", "window-puchase-productinfo");

//                  prod_price.setAttribute("id", "product-price");
//                  prod_price.appendChild(document.createTextNode(" "));

                    return prod_info_container;
                }()),

                    product_star_ratings = (function () {
                        var stars_container = document.createElement("div");

                        stars_container.setAttribute("id", "dpw-reviews");

//                          prod_info_container.appendChild(stars_container);

                        return stars_container;
                    }()),

                    product_title = (function () {
                        var prod_title = document.createElement("h1");

                        prod_title.setAttribute("id", "product-title");
                        prod_title.appendChild(document.createTextNode("No Item"));

//                          prod_info_container.appendChild(prod_title);

                        return prod_title;
                    }()),

                    product_pui = (function () {
                        var purchase_ui_container = document.createElement("div"),
                            tiles_container     = document.createElement("div"),
                            price_info          = document.createElement("ul"),
                            price_info_was      = document.createElement("li"),
                            price_info_now      = document.createElement("li"),
                            stock_status        = document.createElement("span"),
                            qty_box             = document.createElement("select"),
                            add_to_bag_button   = document.createElement("button"),
                            feedback_messages   = document.createElement("div"),
                            progress_spinner    = document.createElement("img");

                        // setup the purchase UI container
                    purchase_ui_container.setAttribute("id", "pop-up-purchase-ui-container");

                    // add the tiles container
                    tiles_container.setAttribute("id", "pop-up-purchase-ui");
                    purchase_ui_container.appendChild(tiles_container);

//                  product_info_DOM.appendChild(purchase_ui_container);

                    // set up price info
                    price_info.setAttribute("id", "ls-price");
                    price_info_was.setAttribute("id", "dpw-was-column");
                        price_info_was.appendChild(document.createTextNode(" "));
                    price_info_now.setAttribute("id", "dpw-now-column");
                        price_info_now.appendChild(document.createTextNode(" "));
                    price_info.appendChild(price_info_was);
                    price_info.appendChild(price_info_now);

                        purchase_ui_container.appendChild(price_info);

                    // set up stock status data
                    stock_status.setAttribute("id", "sp-stock");
                    stock_status.appendChild(document.createTextNode(" "));

                        purchase_ui_container.appendChild(stock_status);

                    // Set up qty box
                    qty_box.setAttribute("id", "sl-pop-up-qty");
                    var c;
                    for (c = 0; c < 10; c++) {
                        var tmp_opt = document.createElement("option");
                        tmp_opt.setAttribute("value", c);
                        tmp_opt.appendChild(document.createTextNode(c));

                        qty_box.appendChild(tmp_opt);
                    }

                    // add qty box to the DOM
                        purchase_ui_container.appendChild(qty_box);
                    // give it an event listener
                        $(qty_box).on("change", function () {
                            twc.cms.add_to_bag.qty = parseInt($(this).val());
                        });


                    // setup add to basket button
                    add_to_bag_button.setAttribute("type", "button");
                    add_to_bag_button.setAttribute("id", "bttn-pop-up-add-to-bag");
                    $(add_to_bag_button).addClass("button-full");
                    add_to_bag_button.appendChild(document.createTextNode("add to bag"));
                    // need to add an event listener
                    $(add_to_bag_button).on("click", {bag_data : twc.cms.add_to_bag}, DPWAddToBag);

                    // add the button to the DOM
                        purchase_ui_container.appendChild(add_to_bag_button);

                    // setup progress spinner
                    progress_spinner.setAttribute("id", "img-spinner");
                    progress_spinner.setAttribute("src", "/images/spinner.gif");
                    progress_spinner.setAttribute("width", "32");
                    progress_spinner.setAttribute("height", "32");
                    progress_spinner.setAttribute("alt", "");
                        purchase_ui_container.appendChild(progress_spinner);

                    // setup the feedback messages div
                    feedback_messages.setAttribute("id", "div-feedback");

                    // add the div to the DOM
                        purchase_ui_container.appendChild(feedback_messages);

                        return purchase_ui_container;
                    }()),

                    product_drawers = (function () {
                        var drawer_list = document.createElement("ul"),
                            drawers_to_make = [
                                "details",
                                "size & care",
                                "delivery",
                                "reviews"
                            ],
                            no_of_drawers = drawers_to_make.length,
                            compiled_drawers = [],
                            i;

                        // setup the collapsible boxes

                        drawer_list.setAttribute("id", "ls-proddetails");

                        for (i = 0; i < no_of_drawers; i++) {
                            var tmp = document.createElement("li"),
                                tmp_drawer = document.createElement("div"),
                                tmp_title = document.createElement("span"),
                                tmp_drawer_contents = document.createElement("div"),
                                tmp_drawer_oflow_content = document.createElement("div");

                            tmp_drawer.setAttribute("id", "collapse2-" + drawers_to_make[i].replace(/[\W\s]/g, ""));
                            if (i !== 0) {
                                tmp_drawer.setAttribute("data-initialclosed", "true");
                            }
                            tmp_drawer.setAttribute("data-closeothers", "true");

                            tmp_title.appendChild(document.createTextNode(drawers_to_make[i]));

                            tmp_drawer_oflow_content.setAttribute("id", drawers_to_make[i].replace(/[\W\s]/g, "") + "-oflow-content");

                            tmp_drawer_oflow_content.appendChild(document.createTextNode(" "));

                            tmp_drawer_contents.appendChild(tmp_drawer_oflow_content)

                            tmp_drawer.appendChild(tmp_title);

                            tmp_drawer.appendChild(tmp_drawer_contents);

                            tmp.appendChild(tmp_drawer);

                            drawer_list.appendChild(tmp);
                        }

                        return drawer_list;
                    }()),

                script_container_element = (function () {
                    // create a div for sjGetResponseLocal function to inject into
                    var script_container = document.createElement("div");

                    script_container.setAttribute("id", "script-container");

                    return script_container;

                }()),

                initDesktopDOM  = function () {

                    var desktop_DOM = (function () {
                        var more_details_link = document.createElement("p"),
                            more_details_a  = document.createElement("a");

                        product_info_DOM.appendChild(product_star_ratings);
                        product_info_DOM.appendChild(product_title);
                        product_info_DOM.appendChild(product_pui);
                        product_info_DOM.appendChild(product_drawers);

                        more_details_a.appendChild(document.createTextNode("More Details"));

                        $(more_details_link).attr("id", "more-details-link");
                        more_details_link.appendChild(more_details_a);

                        product_info_DOM.appendChild(more_details_link);



                        return product_info_DOM;
                    }());

                    // init
                    purchase_window_DOM.appendChild(image_container_DOM);
                    purchase_window_DOM.appendChild(desktop_DOM);

                    blackout.appendChild(purchase_window_DOM);

                    // add window to the body
                    document.body.appendChild(blackout);

                    // setup zoom and collapsible boxes
                    //twcZoom("main-img", 4);

                    collapsingBoxes2($("[id|=collapse2]"));
                },

                initMobileDOM   = function () {


                    var tab_ui = document.createElement("ul"),
                        image_li = document.createElement("li"),
                        selectButton = (function () {
                            var prev_bttn = null;

                            return function (bttn) {


                                if (!prev_bttn) {
                                    prev_bttn = document.getElementById("trigger-window-purchase-imagecontainer");
                                }
                                if (bttn !== prev_bttn) {
                                    $(bttn).addClass("mob-selected-bttn");
                                    $(prev_bttn).removeClass("mob-selected-bttn");
                                }

                                prev_bttn = bttn;
                            }
                        }()),
                        selectTab = (function () {
                            var prev_tab = null;

                            return function (tab) {

                                if (!prev_tab) {
                                    prev_tab = document.getElementById("window-purchase-imagecontainer");
                                }
                                if (tab !== prev_tab) {
                                    if (tab === document.getElementById("window-purchase-imagecontainer")) {
                                        $(tab).removeClass("invisible");
                                    }
                                    else {
                                        $(tab).show();
                                    }
                                    if (!$(tab).hasClass("mob-selected")) {
                                        $(tab).addClass("mob-selected");
                                    }
                                    if (prev_tab === document.getElementById("window-purchase-imagecontainer")) {
                                        $(prev_tab).addClass("invisible");
                                    }
                                    else {
                                        $(prev_tab).hide();
                                    }
                                    if ($(prev_tab).hasClass("mob-selected")) {
                                        $(prev_tab).removeClass("mob-selected");
                                    }

                                    prev_tab = tab;
                                }
                            }
                        }());

                    tab_ui.setAttribute("id", "mobile-tabs");

                    // for (var i = 0; i < 3; i++) {
//                      $(tab_ui).append("<li>tab</li>");
//                  }

                    // prep tabs ui

                    image_li.appendChild(image_container_DOM);

                    product_drawers.insertBefore(image_li, product_drawers.firstChild);

                    $(product_drawers).children().each(function () {
                        var temp = document.createElement("li"),
                            temp_inner = document.createElement("div");

                        $(temp).attr("data-for", $(this).children("div").attr("id"));

                        $(temp_inner).attr("id", "trigger-" + $(this).children("div").attr("id"));
                        temp.appendChild(temp_inner);

                        $(tab_ui).append(temp);

                        $(temp).on("click", function () {
                            selectButton(document.getElementById("trigger-" + $(temp).attr("data-for")));
                            selectTab(document.getElementById($(temp).attr("data-for")));
                        });
                    });

                    // add final tab for quick buy
                    var quick_buy_bttn = document.createElement("li");
                    $(quick_buy_bttn).attr("data-for", "pop-up-purchase-ui-container");

                    $(quick_buy_bttn).append("<div id=\"trigger-pop-up-purchase-ui-container\">quick buy</div>");
                    $(tab_ui).append(quick_buy_bttn);

                    $(quick_buy_bttn).on("click", function () {
                        selectButton(document.getElementById("trigger-" + $(this).attr("data-for")));
                        selectTab(document.getElementById($(this).attr("data-for")));

                    });


                    purchase_window_DOM.appendChild(product_star_ratings);
                    purchase_window_DOM.appendChild(product_title);
                    purchase_window_DOM.appendChild(tab_ui);
                    purchase_window_DOM.appendChild(product_drawers);
                    purchase_window_DOM.appendChild(product_pui);


                    blackout.appendChild(purchase_window_DOM);

                    // add window to the body
                    document.body.appendChild(blackout);

                    $("#product-purchase-window-container").on("resize", function () {
                        _mobReInit();
                    });

                    // sort out tab labels
                    $("#trigger-window-purchase-imagecontainer").append("images");
                    $("#trigger-collapse2-details").append("details");
                };



            // init

            // define amplienceFns

            amplienceFns = {
                allAmpliencePubs : (function () {
                    if (interact.apps) {
                        var all_ids = [];

                        for (prop in interact.apps) {
                            all_ids.push(prop);
                        }



                        return all_ids;
                    }
                    else {
                        return false;
                    }
                }()),

                pausePubs : function () {
                    var i,
                        api,
                        pubs = amplienceFns.allAmpliencePubs;



                    for (i = pubs.length - 1; i >= 0; i--) {
                        api = interact.getApp(pubs[i]);
                        if (api) {

                            api.pauseModule();
                        }
                    };
                },

                playPubs : function () {
                    var i,
                        api,
                        pubs = amplienceFns.allAmpliencePubs;



                    for (i = pubs.length - 1; i >= 0; i--) {
                        api = interact.getApp(pubs[i]);
                        if (api) {

                            api.playModule();
                        }
                    };
                }
            };

            // redefine the scene7 function
            sjGetResponseLocal = function (inReq, inImg, inCallback, inErrCallback) {
                var tempi = inImg.indexOf("?");
                var tempmod = "";
                if(tempi >= 0){
                    tempmod = inImg.substring(tempi+1);
                    inImg = inImg.substring(0,tempi);
                }

                var urljson = S7ConfigClient.isRoot + '/' + inImg + '?' + inReq;

                if (tempmod){
                    urljson += '&' + tempmod;

                }

                var id = sjHashCode(urljson);
                urljson += '&id=' + id;
                if (typeof inCallback != 'undefined'){
                    sjCallbacks[id] = inCallback;
                }
                if (typeof inErrCallback != 'undefined'){
                    sjErrCallbacks[id] = inErrCallback;
                }
                $("#script-container").empty().html("<script language='javascript' src='" + urljson + "'><\/script>");
                //document.write("<script language='javascript' src='" + urljson + "'><\/script>");
            }
            // add a div for this function to add to
            document.body.appendChild(script_container_element);

            if (mobile && isMobile) {
                initMobileDOM();
//              initDesktopDOM();
            }
            else {
                initDesktopDOM();
//              initMobileDOM();
            }
            // add event listeners
            $("#window-purchase-close").on("click", function () {
                if (!!$("#div-feedback").html()) {
                    $("#div-feedback").empty();
                }
                $("#product-purchase-window-container").fadeOut(500);
                if (amplienceFns.allAmpliencePubs.length > 0) {
                    amplienceFns.playPubs();
                }
            });


        },

        // update mini basket function
        updateMiniBasket = function (new_count, new_price) {
            var current_basket_count    = parseInt(document.getElementById("lblItemCount").firstChild.nodeValue),
                current_basket_total    = document.getElementById("ltotal").firstChild.nodeValue.replace(/[^0-9\.]/, ""),
                comma                   = /\,/,

                // private methods

                formatMiniBasketTotal   = function (total_to_format) {
                    var new_total = (total_to_format.toFixed(2)).toString(),
                        no_of_digits = new_total.slice(0, new_total.search(/\./)),
                        pre_comma,
                        post_comma,
                        formatted_total;

                    if (no_of_digits.length >= 4) {

                        pre_comma = new_total.slice(0, no_of_digits.length - 3);

                        post_comma = new_total.slice(no_of_digits.length - 3);

                        formatted_total = pre_comma + "," + post_comma;
                    }
                    else {
                        formatted_total = new_total;
                    }

                    return formatted_total;
                };

            // remove comma's if any from the current_basket_total
            if (comma.test(current_basket_total)) {
                current_basket_total = current_basket_total.replace(",", "");
            }

            current_basket_total = parseFloat(current_basket_total);

            // calculate new basket count
            new_basket_count = current_basket_count + new_count;
            new_basket_price = current_basket_total + (new_price * new_count);

            // update the mini basket
            $("#lblItemCount").empty().html(new_basket_count);
            $("#ltotal").empty().html("&pound;" + formatMiniBasketTotal(new_basket_price));
        },

        // touch tiles functionality - colour
        colourTouchTileFn = (function () {
            var tile_to_deselect = null;

            return function () {
                var grouped = false,
                    sizes_available,
                    add_to_bag_bttn = $("#bttn-pop-up-add-to-bag"),
                    i;

                if ($(this).parent().attr("data-grouped")) {
                    grouped = true;
                    sizes_available = $(this).find("ul > li > ul > li");
                }
                else {
                    sizes_available = $(this).find("ul > li")
                }

                if (tile_to_deselect) {
                    $(tile_to_deselect).removeClass("selected");
                }
                $(this).addClass("selected");
                // select first available size
                for (i = 0; i < sizes_available.length; i++) {
                    if ($(sizes_available[i]).attr("data-stock").toLowerCase() !== "sold out") {
                        sizeTouchTileFn.call(sizes_available[i]);
                        if ($("#bttn-pop-up-add-to-bag").attr("disabled")) {
                            $("#bttn-pop-up-add-to-bag").removeAttr("disabled");
                            $("#bttn-pop-up-add-to-bag").css({
                                "opacity"   : 1,
                                "cursor"    : "pointer"
                            });
                            $("#sl-pop-up-qty").removeAttr("disabled");
                            $("#sl-pop-up-qty").val(1);
                        }

                        // grouped function

                        if (grouped) {
                            $(sizes_available[i]).parents("li").eq(0).click();
                        }

                        break;
                    }
                    else if ((i === (sizes_available.length - 1)) && ($(sizes_available[i]).attr("data-stock").toLowerCase() === "sold out")) {
                        // all sizes are sold out
                        $("#dpw-was-column").empty();
                        $("#dpw-now-column").empty();
                        $("#sp-stock").empty().html("sold out");
                        $("#bttn-pop-up-add-to-bag").attr("disabled", "true");
                        $("#bttn-pop-up-add-to-bag").css({
                            "opacity"   : 0.2,
                            "cursor"    : "auto"
                        });
                    }
                }
                // handle out of stock items
                if ($("#sp-stock").html().toLowerCase() === "sold out")  {
                    // the selection is sold out - disable add to bag
                    $("#bttn-pop-up-add-to-bag").attr("disabled", "true");
                    $("#bttn-pop-up-add-to-bag").css({
                        "opacity"   : 0.2,
                        "cursor"    : "auto"
                    });
                    $("#sl-pop-up-qty").attr("disabled", "disabled");
                    $("#sl-pop-up-qty").val(0);
                }
                tile_to_deselect = this;

                // select the first available item in this list
                //$("#")


            }
        }()),

        // touch tiles functionality - colour
        sizeTouchTileFn = (function () {
            var tile_to_deselect = null;

            return function () {
                // event.stopPropagation();
                if (tile_to_deselect) {
                    $(tile_to_deselect).removeClass("selected");
                }
                $(this).addClass("selected");
                tile_to_deselect = this;

                // prep the add_to_bag object with the correct values

                if ($(this).attr("data-wasprice")) {
                    var was_price = $(this).attr("data-wasprice").replace(/[^0-9\.]/, "").replace(/\,/g, "");
                }
                else {
                    var was_price = null;
                }
                var now_price = $(this).attr("data-nowprice").replace(/[^0-9\.]/, "").replace(/\,/g, "");

                // update the display on PUI

                if (was_price) {
                    $("#dpw-was-column").html("&pound;" + was_price);
                    $("#dpw-now-column").html("<span class=\"red\">&pound;" + now_price + "</span>");
                }
                else if (!was_price) {
                    $("#dpw-was-column").empty();
                    $("#dpw-now-column").html("&pound;" + now_price);
                }

                $("#sp-stock").html($(this).attr("data-stock").toLowerCase());

                // select a qty of 1
                $("#sl-pop-up-qty").val(1);

                twc.cms.add_to_bag.basket_price = parseFloat(document.getElementById("ltotal").firstChild.nodeValue.replace(/[^0-9\.]/, "").replace(/\,/g, ""));
                twc.cms.add_to_bag.sku = $(this).attr("data-variant");
                twc.cms.add_to_bag.qty = parseInt(document.getElementById("sl-pop-up-qty").value);
                twc.cms.add_to_bag.price = parseFloat( now_price );

            }
        }()),

        productTypeTabsFn = (function () {
            var tab_to_deselect = null;

            return function () {
                if (tab_to_deselect) {
                    $(tab_to_deselect).removeClass("selected");
                }
                $(this).addClass("selected");
                tab_to_deselect = this;

                // find and select first available size in this group
                var sizes_available = $(this).find("ul > li"),
                    total_sizes = sizes_available.length,
                    c;

                for (c = 0; c < total_sizes; c++) {
                    if ($(sizes_available[c]).attr("data-stock").toLowerCase() !== "sold out") {
                        sizeTouchTileFn.call(sizes_available[c]);
                        if ($("#bttn-pop-up-add-to-bag").attr("disabled")) {
                            $("#bttn-pop-up-add-to-bag").removeAttr("disabled");
                            $("#bttn-pop-up-add-to-bag").css({
                                "opacity"   : 1,
                                "cursor"    : "pointer"
                            });
                            $("#sl-pop-up-qty").removeAttr("disabled");
                            $("#sl-pop-up-qty").val(1);
                        }
                        break;
                    }
                    else if ((i === (sizes_available.length - 1)) && ($(sizes_available[c]).attr("data-stock").toLowerCase() === "sold out")) {
                        // all sizes are sold out
                        $("#dpw-was-column").empty();
                        $("#dpw-now-column").empty();
                        $("#sp-stock").empty().html("sold out");
                        $("#bttn-pop-up-add-to-bag").attr("disabled", "true");
                        $("#bttn-pop-up-add-to-bag").css({
                            "opacity"   : 0.2,
                            "cursor"    : "auto"
                        });
                    }
                }

            }
        }()),

        // function to build (or retrieve) the purchase UIs
        popupPUI = (function () {
            var all_pui                 = {};

            return function (data, sku) {
                var $purchase_ui_container  = $("#pop-up-purchase-ui"),
                    tmp_fragment            = document.createElement("div"),
                    ref_id                  = data.itemid;

                if (ref_id in all_pui) {

                    var this_pui = all_pui[ref_id];
                    // if this hotspot has already been built and produced a PUI before - then fetch it

                    $purchase_ui_container.children("div").detach();



                    if ($(this_pui).hasClass("grouped") === true) {
                        $purchase_ui_container.addClass("grouped");
                    }
                    if ($(this_pui).hasClass("grouped") === false) {
                        $purchase_ui_container.removeClass("grouped");
                    }

                    $purchase_ui_container.append(this_pui);

                    // now click the first combo
                    $("#pop-up-purchase-ui > div > ul >li").eq(0).click();
                }
                else {
                    // assume build with one single variant

                    // if it hasn't then build a new PUI for it from data coming from the API then add it to the 'all_pui' object

                    var this_pui_ref = data.itemid;

                    var colour_list = document.createElement("ul");
                    //var size_list = document.createElement("ul");



                    var data_array = data.SizesByColors;

                    $(data_array).each(function () {
                        if ("Color" in this && "Sizes" in this.ProductType[0]) {
                            var pui_color = $(document.createElement("li")).text(this.Color),
                                pui_sizes_tmp,
                                tmp_group_li,
                                no_of_producttypes;

                            var pui_groups,
                                use_groups = false;

                            if (typeof sku === "string") {

                                use_groups = true;
                                $("#pop-up-purchase-ui").addClass("grouped");
                                $(tmp_fragment).addClass("grouped");
                                pui_groups = document.createElement("ul");
                                no_of_producttypes = this.ProductType.length;
                            }
                            else {
                                $("#pop-up-purchase-ui").removeClass("grouped");
                            }

                            $(pui_color).on("click", function (event) {
                                event.stopPropagation();
                                if (event.target.nodeName.toLowerCase() === "li") {
                                    if (!!$("#div-feedback").html()) {
                                        $("#div-feedback").empty();
                                    }
                                    colourTouchTileFn.call(pui_color);
                                }
                            });

                            $(this.ProductType).each( function (index) {
                                pui_sizes_tmp = document.createElement("ul");

                                if (use_groups) {
                                    tmp_group_li = document.createElement("li");

                                    $(tmp_group_li).text(this.ProductType);
                                };

                                $(this.Sizes).each( function () {
                                    var tmp_li = document.createElement("li");

                                    if (this.wasprice) {
                                        $(pui_sizes_tmp).append($(tmp_li).text(this.size).attr({
                                                "data-wasprice" : this.wasprice,
                                                "data-nowprice" : this.nowprice,
                                                "data-stock"    : this.inventorystatus,
                                                "data-variant"  : this.variant
                                            }
                                        ));
                                    }
                                    else {
                                        $(pui_sizes_tmp).append($(tmp_li).text(this.size).attr({
                                                "data-nowprice" : this.nowprice,
                                                "data-stock"    : this.inventorystatus,
                                                "data-variant"  : this.variant
                                            }
                                        ));
                                    }

                                    if (this.inventorystatus.toLowerCase() !== "sold out") {
                                        $(tmp_li).on("click", function (event) {
                                            event.stopPropagation();
                                            if (event.target.nodeName.toLowerCase() === "li") {
                                                if (!!$("#div-feedback").html()) {
                                                    $("#div-feedback").empty();
                                                }
                                                sizeTouchTileFn.call(this);
                                            }
                                        });
                                    }
                                });

                                if (use_groups) {
                                    $(tmp_group_li).on("click", function (event) {
                                        event.stopPropagation();
                                        if (event.target.nodeName.toLowerCase() === "li") {
                                            productTypeTabsFn.call(this);
                                        }
                                    });

                                    /*if (index == (no_of_producttypes - 1)) {
                                        $(tmp_group_li).css("border-bottom-width", "1px");
                                    }*/
                                    // add sprite icon holder
                                    tmp_group_li.appendChild(document.createElement("span"));
                                    $(tmp_group_li).append(pui_sizes_tmp);

                                    $(pui_groups).append(tmp_group_li);
                                }



                            });

                            // $(pui_sizes_tmp).append(pui_sizes_tmp);

                            if (use_groups) {
                                // add the groups to the color instead of the sizes
                                $(pui_color).append(pui_groups);
                                $(colour_list).attr("data-grouped", "true");
                            }
                            else {
                                $(pui_color).append(pui_sizes_tmp);
                            }

                            $(colour_list).append(
                                pui_color
                            );
                        }
                        //else {
                            //
                        //}
                    });


                    tmp_fragment.appendChild(colour_list);


                    // give the hotspot clicked the ref code for it's PUI
                    //$(this).attr("data-pui-ref", this_pui_ref);

                    // fully rendered UI to be appended to tmp_fragment variable...
                        // ...then added to the all_pui object with reference to the itemid
                    all_pui[this_pui_ref] = tmp_fragment;

                    $purchase_ui_container.children("div").detach(); // remove any existent, visible PUI's
                    $purchase_ui_container.append(tmp_fragment);

                    // now click the first colour
                    $(tmp_fragment).find("ul > li").eq(0).click();

                    //tmp_fragment = "";  make the tmp_fragment empty to avoid any unintended DOM going in
                }
            }
        }()),

        // function to fetch data for the hotspot clicked
        getHotspotData = function (sku_code, tagging) {
            var api_url             = "/productdetailsapi.aspx",
                api_url_with_get    = "/productdetailsapi.aspx?sku=",
                tagging             = false || tagging;


            /*$.post(api_url, {
                    sku : sku_code
                },
                function (data) {

                    return_data = data;
                    updateDPWPopUp(return_data);
                    popupPUI(return_data);
                    _showDPW();

                },
                "json");
            */

            $.getJSON(api_url_with_get + sku_code, function (data) {
                if (dpw_config) {
                    return_data = data;
                    initializeJSON(return_data.defaultimage.replace("https://whitecompany.scene7.com/is/image/whitecompany/", ""));
                    updateDPWPopUp(return_data, sku_code, _showDPW);
                    if (tagging) {

                        _taggingFn(data.link);
                    }
                }
                else {
                    window.location.assign(data.link);
                }
            });

        },

        // update pop up functionality
        updateDPWPopUp = function (hotspot_data, sku, callback) {
            var //image_set         = initializeJSON(hotspot_data.defaultimage + "?req=imageset"),
                scene_7_url         = "https://whitecompany.scene7.com/is/image/", // scene7 portion of the URL - without the company name
                src_pairs           = [], // first split by comma - which separate the string into pairs of indententical semi-colon separated values
                first_src           = "",
                main_img_preset     = "$Main326x326$",
                zoomed_img_preset   = "$Zoom1392x1392$",
                alt_img_preset      = "$Thumb163x163$",
                c,
                i,
                i_start,
                no_of_alts,
                t                   = setInterval(function checkImagesets() {
                    if (imagset.length == 0) {

                        // checkImagesets();
                    }
                    else {
                        clearInterval(t);
                        if (!imagset[0].IMAGE_SET) {
                            for (c = 1; c < imagset.length; c++) {
                                src_pairs.push(imagset[c].IMAGE_SET.split(","));

                            }
                        }
                        else {
                            src_pairs = imagset[0].IMAGE_SET.split(",");
                        }
                        first_src = scene_7_url.concat((src_pairs.toString()).split(";")[0]);

                        // reviews

                        if (hotspot_data.reviewstats) {
                            $("#dpw-reviews").empty();
                            $("#dpw-reviews").html(hotspot_data.reviewstats);
                        }
                        else {
                            $("#dpw-reviews").empty();
                        }


                        $("#product-title").html(hotspot_data.name);

                        // as a prep - clear was/now price - and make stock sold out
                        $("#dpw-was-column").empty();
                        $("#dpw-now-column").empty();
                        $("#sp-stock").empty().html("sold out");


                        $("#product-price").html(hotspot_data.SizesByColors[0].ProductType[0].Sizes[0].nowprice);


                        if ($("#collapse2-details").hasClass("collapse2-closed")) {
                            $("#collapse2-details > span > .widget").click();
                        }

                        $("#details-oflow-content").html(hotspot_data.description);

                        if (!hotspot_data.careinstructions) {
                            $("#collapse2-sizecare").css("display", "none");
                            $("#sizecare-oflow-content").empty();
                        }
                        else {
                            $("#collapse2-sizecare").css("display", "block");
                            $("#sizecare-oflow-content").html(hotspot_data.careinstructions);
                        }

                        $("#delivery-oflow-content").html(hotspot_data.deliverydetails);

                        if (!hotspot_data.reviewsdata) {
                            $("#collapse2-reviews").css("display", "none");
                            $("#reviews-oflow-content").empty();
                        }
                        else {
                            $("#collapse2-reviews").css("display", "block");
                            $("#reviews-oflow-content").empty().html(hotspot_data.reviewsdata);
                        }

                        // more details link
                        $("#more-details-link > a").attr("href", hotspot_data.link);

                        // image setup
                            // main img
                        $("#main-img").attr("src", first_src + "?" + main_img_preset);
                            // zoomed image
                        $("#window-purchase-mainimg_zoomed_img").attr("src", $("#main-img").attr("src").replace(main_img_preset, zoomed_img_preset));
                            // alternative images

                        // clear previous alts
                        $("#alt-imgs-list").empty();

                        // sort out alts
                        if ((!mobile && !isMobile) || (mobile && !isMobile) || (!mobile && isMobile)) {
                            i_start = 1;
                            no_of_alts = src_pairs.length - 1;
                            // set alt imgs ul width
                            $("#alt-imgs-list").css(
                                "width", (no_of_alts) * ($("#main-img").width() / (i_start * 2))
                            );
                        }
                        else {
                            i_start = 0;
                            no_of_alts = src_pairs.length;
                        }



                        for (i = i_start; i < src_pairs.length; i++) {
                            var tmp_img = document.createElement("img"),
                                tmp_li  = document.createElement("li");

                            if ((!mobile && !isMobile) || (mobile && !isMobile)) { // desktop || iPad
                                $(tmp_img).attr({
                                    "alt"       : "",
                                    "src"       : scene_7_url + (src_pairs[i].toString()).split(";")[0] + "?" + alt_img_preset,
                                    "width"     : "163",
                                    "height"    : "163"
                                });

                                $(tmp_img).on("click", function (event) {
                                    event.stopPropagation();
                                    imageSelector.call(event.target);
                                });
                            }
                            else if (!mobile && isMobile) {
                                $(tmp_img).attr({
                                    "alt"       : "",
                                    "src"       : scene_7_url + (src_pairs[i].toString()).split(";")[0] + "?" + alt_img_preset,
                                    "width"     : "163",
                                    "height"    : "163"
                                });

                                $(tmp_img).on("click", function (event) {
                                    event.stopPropagation();
                                    imageSelector.call(event.target);
                                });

                                $("#product-purchase-window-container").css("position", "absolute");
                            }
                            else { // mobile
                                $(tmp_img).attr({
                                    "alt"       : "",
                                    "src"       : scene_7_url + (src_pairs[i].toString()).split(";")[0] + "?wid=" + screen.availHeight + "&hei=" + screen.availHeight + "&qlt=70,0&resMode=sharp2&op_usm=1,1,8,0",
                                    "width"     : "100%",
                                    "height"    : "100%"
                                });
                            }

                            //$("#alt-imgs-list").empty();

                            $("#alt-imgs-list").append($(tmp_li).append(tmp_img));

                            //$("#alt-imgs-list").html("<li><img src=\"" + scene_7_url + (src_pairs[i].toString()).split(";")[0] + "\" alt=\"\"><li>");
                        }


                        // fetch the correct PUI or build one
                        // check for params
                        if ((sku.indexOf("&") !== -1) && (sku.indexOf("&type") === -1)) {
                            var params = sku.substring(sku.indexOf("&"));
                        }
                        else {
                            var params = false;
                        }

                        popupPUI(hotspot_data, params);

                        if (typeof callback == "function") {
                            callback();
                        }
                    }
                }, 250);

        },

        // add to basket function for Dynamic Product Window (DPW)

        DPWAddToBag = function (event) {
            var add_to_bag_url  = "/addtobagapi.aspx",
                variant         = event.data.bag_data.sku,
                qty             = event.data.bag_data.qty,
                price           = event.data.bag_data.price,
                $feedback_div   = $("#div-feedback");

            $feedback_div.empty();

            if (qty > 0) {
                // show spinner in place of button
                var button = this;

                $(button).fadeOut("fast", function () {
                    if (mobile && isMobile) {
                        $("#img-spinner").css({
                            opacity: 0,
                            display: "block"
                        });
                        $("#img-spinner").animate({
                            opacity: 1
                        }, "fast");
                    }
                    else {
                        $("#img-spinner").fadeIn("fast");
                    }
                });


                var $post_bag = $.post(add_to_bag_url,
                       {
                            apivariantid    : variant,
                            apiqty          : qty
                       }
                );
                $post_bag.done(function (data) {
                        // feedback
                        if (qty > 1) {
                            $feedback_div.html("Your items have been added to the shopping bag");
                        }
                        else if (qty === 1) {
                            $feedback_div.html("Your item has been added to the shopping bag");
                        }

                        $("#sl-pop-up-qty").val(0);
                        twc.cms.add_to_bag.qty = 0;
                        $("#img-spinner").fadeOut("fast");
                        $(button).fadeIn("fast");

                        // trigger mini basket update

                        updateMiniBasket(qty, price);
                });
            }
            else {
                $feedback_div.html("<span class=\"red\">You must select an item quantity</span>");
            }
        },

        _placeholderInfo = function () {
            var title = document.getElementById("product-title"),
                price = document.getElementById("product-price"),
                lorem_text = "  Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.";

            // $("#main-img").attr("src");
//          $("#first-alt-image-container").attr("src");
//          $("#second-alt-image-container").attr("src");
//          $("#star-rating").attr("src");

                $(title).html("Product Title");
                $(price).html("From &pound;XX");
                $("#details-oflow-content").html(lorem_text);
                $("#sizecare-oflow-content").html(lorem_text);
                $("#delivery-oflow-content").html(lorem_text);
                $("#reviews-oflow-content").html(lorem_text);

        },// temporary for dev only

        // mobile reInit
        _mobReInit = function () {
            var $product_list_elmnt = $("#ls-proddetails"),
                $pui_elmnt = $("#pop-up-purchase-ui-container"),
                correct_pos = $product_list_elmnt.position().top;



            $pui_elmnt.css("top", correct_pos);
        },

        _showDPW = function () {
            $("#product-purchase-window-container").fadeIn();
            // init the swipe carousel
            var elem = document.getElementById("alt-imgs-container");
            var $setImages = $("#alt-imgs-list").find("img");

            if (mobile && isMobile) {
                _mobReInit();
                $("li[data-for=\"window-purchase-imagecontainer\"]").click();


                utils.waitForAllImages($setImages, function(){
                    if(elem){
                        window.mySwipe = Swipe(elem, {
                            // startSlide: 4,
                            //auto: 3000,
                            // continuous: true,
                            // disableScroll: true,
                            // stopPropagation: true,
                            // callback: function(index, element) {},
                            // transitionEnd: function(index, element) {}
                            //callback: function(position) {}
        
                            }); // end swipe
                    }

                });

            }

            if (amplienceFns.allAmpliencePubs.length > 0) {
                amplienceFns.pausePubs();
            }
        },


        aniScroll = (function (content) {
                    var position = $(content).offset().top;

                    $("body").animate({ scrollTop: position }, 500 );

        }),

        // for tagging

        _taggingFn = (function () {
            var iframe_for_tags = (function () {
                    var iframe = document.createElement("iframe");

                    $(iframe).attr({
                        width   : "0",
                        height  : "0",
                        id      : "iframe-tagging"
                    });
                    $(iframe).css({
                        "margin"        : "0",
                        "border"        : "none",
                        "visibility"    : "hidden"
                    });

                    return iframe;
                }()),
                $iframe = null;

            return function (prod_link) {
                if (!document.getElementById("iframe-tagging")) {
                    //
                    document.body.appendChild(iframe_for_tags);
                    $iframe = $("#iframe-tagging");
                    $iframe.attr("src", prod_link);
                }

                //

                $iframe.attr("src", prod_link);
            }

        }());


        // Public API
        return {
            aniScroll : aniScroll,
            drawers : collapsingBoxes2,
            initDPWPopUp: initDPWPopUp,
            getHotspotData: getHotspotData,
            updateDPWPopUp: updateDPWPopUp,
            add_to_bag : {
                sku : null,
                qty : 0,
                price : 0,
                basket_price: 0
            },
            _showDPW: _showDPW
        }
}());


/*

Plugins module - to contain  site plugin functionality and components

*/

/**
*
* @class plugins
*
*/

twc.plugins = (function () {

    var carouselX = (function () {

    //  private methods
        var initCarousel = function (carousel_elmt) {

            var $this_carousel  = $(carousel_elmt),
                $ribbon         = null,
                $viewport       = {},
                carousel_width  = null,
                view_no         = 4,
                scroll_no       = view_no,
                no_of_items     = null,
                width_of_item   = null,
                next_bttn       = null,
                prev_bttn       = null,
                infinite        = false,
                xfade           = false,
                left_edge       = 0,
                indicators      = false,
                current_in_view = 1,
                // less_double      = false,

                // private methods

                scrollNext      = function () {

                    var ribbon_pos = parseInt($ribbon.css("left")),
                        //scroll_adjust = 0,
                        button = this,
                        move,
                        shuffleNext = function () {
                            var first_items = $ribbon.children().slice(0, scroll_no);
                            console.log(scroll_no);

                            $(first_items).appendTo($ribbon);
                        };

                    // save a property of the function

                    scroll_length = Math.abs(scroll_length);

                //  Infinate Scroll
                //  ===============
                    if ( infinite )
                    {
                        $(button).attr("data-inprogress", "true");
                    //  move first items to the end
                        if ( !xfade )
                        {
                            $ribbon.animate({
                                left : ( ribbon_pos - scroll_length )
                            }, 500, function () {
                                shuffleNext();
                                $ribbon.css( "left", left_edge );
                                $(button).removeAttr("data-inprogress");
                            });
                        }
                        else {
                            shuffleNext();
                            $ribbon.children("li:first-child").animate({
                                opacity : 1
                            }, 500, function () {
                                $ribbon.children().slice(1).css("opacity", 0);
                                $(button).removeAttr("data-inprogress");
                            });
                        }

                    }

                //  Bounded Scroll
                //  ==============
                    else
                    {
                        if (
                            (ribbon_length - Math.abs(ribbon_pos)) > $viewport.width &&
                            (ribbon_length - Math.abs(ribbon_pos - scroll_length) > $viewport.width)
                        ) {
                            move = ribbon_pos - scroll_length;
                            $(button).attr("data-inprogress", "true");
                            $(prev_bttn).removeClass("carouselx-disabled");
                        }
                        // if the ribbon length - current position is less than the viewport - will need to scroll less!
                        else if (
                            ((ribbon_length - Math.abs(ribbon_pos - scroll_length)) <= $viewport.width) &&
                            (ribbon_pos !== max_left)
                        ) {
                            move = max_left;
                            $(button).attr("data-inprogress", "true").addClass("carouselx-disabled");
                            $(prev_bttn).removeClass("carouselx-disabled");
                        }

                        $ribbon.animate({
                            left : move
                        }, 500, function () {
                            $(button).removeAttr("data-inprogress");
                        });
                    }


                    if (indicators !== false) {
                        if (current_in_view >= no_of_items) {
                            if (!infinite) {
                                current_in_view = no_of_items;
                            }
                            else {
                                current_in_view = 1;
                            }
                        }
                        else if (current_in_view < 1) {
                            current_in_view = no_of_items;
                        }
                        else {
                            current_in_view++;
                        }
                        console.log("no_of_items : " + no_of_items);
                        console.log("in view : " + current_in_view);

                        if (indicators === "numbers") {
                            // $this_carousel.find(".carouselx-current-slide").text(current_in_view);
                            $("#" + $this_carousel.attr("id") + "-numberindex").text(current_in_view);
                        }
                        else { // use default dots
                            // $this_carousel.find(".carouselx-dotindex > li.current").removeClass("current");
                            $("#" + $this_carousel.attr("id") + "-dotindex > li").removeClass("current");

                            $("#" + $this_carousel.attr("id") + "-dotindex > li").eq(current_in_view - 1).addClass("current");
                        }
                    }

                },

                scrollPrev      = function () {
                    var ribbon_pos = parseInt($ribbon.css("left")),
                        button = this,
                        move,
                        shufflePrev = function () {
                            var last_items = $ribbon.children().slice($ribbon.children().length - scroll_no);
                            $(last_items).insertBefore($ribbon.children("li:first-child"));
                        };

                    scroll_length = Math.abs(scroll_length) * -1;

                //  Infinate Scroll
                //  ===============
                    if ( infinite )
                    {
                        $(button).attr("data-inprogress", "true");
                            
                        //  move last items to the start

                            if (!xfade) {
                                $ribbon.animate({
                                    left : (ribbon_pos - scroll_length)
                                }, 500, function () {
                                    shufflePrev();
                                    $ribbon.css("left", left_edge);
                                    $(button).removeAttr("data-inprogress");
                                });
                            }
                            else {
                                shufflePrev();
                                $ribbon.children("li:first-child").animate({
                                    opacity : 1
                                }, 500, function () {
                                    $ribbon.children().slice(1).css("opacity", 0);
                                    $(button).removeAttr("data-inprogress");
                                });
                            }

                    }

                //  Bounded Scroll
                //  ==============
                    else
                    {
                    //  A whole cell left to scroll
                        if ( ribbon_pos < 0 &&
                            (ribbon_length - Math.abs(ribbon_pos)) >= $viewport.width &&
                            ((ribbon_pos - scroll_length) < 0)
                        ) {
                            move = ribbon_pos - scroll_length;
                            $(button).attr("data-inprogress", "true");
                            $(next_bttn).removeClass("carouselx-disabled");
                        }
                    //  No whole cell left to scroll
                        else if (Math.abs(ribbon_pos - scroll_length) <= $viewport.width)
                        {
                            move = max_right;
                            $(button).attr("data-inprogress", "true").addClass("carouselx-disabled");
                            $(next_bttn).removeClass("carouselx-disabled");
                        }

                        $ribbon.animate({
                            left : move
                        }, 500, function () {
                            $(button).removeAttr("data-inprogress");
                        });
                    }

                //  Indicators
                //  ==========
                    if (indicators) {
                        if (current_in_view <= 1) {
                            if (!infinite) {
                                current_in_view = 1;
                            }
                            else {
                                current_in_view = no_of_items;
                            }
                        }
                        else {
                            current_in_view--;
                        }
                        console.log("in view : " + current_in_view);

                        if (indicators === "numbers") {
                            // $this_carousel.find(".carouselx-current-slide").text(current_in_view);
                            $("#" + $this_carousel.attr("id") + "-numberindex").text(current_in_view);
                        }
                        else { // use default dots
                            // $this_carousel.find(".carouselx-dotindex > li.current").removeClass("current");
                            $("#" + $this_carousel.attr("id") + "-dotindex > li").removeClass("current");

                            $("#" + $this_carousel.attr("id") + "-dotindex > li").eq(current_in_view - 1).addClass("current");
                        }
                    }
                },

                detectSwipe = function () {
                    var initial_touch = 0,
                        swipe_distance = 0,
                        moved = 0,
                        scroll_start = 0,
                        scroll_distance = 0;

                    $(this).on("touchstart", function (event) {
                        var touch = event.originalEvent.changedTouches[0];
                        // prevent URLs being followed
                        //event.preventDefault();

                        initial_touch = touch.clientX;
                        scroll_start = touch.clientY;

                        //


                    });
                    $(this).on("touchmove", function (event) {
                        var touch = event.originalEvent.changedTouches[0],
                            scroll_distance = 0;
                        // prevent URLs being followed
//                      event.preventDefault();

                        scroll_distance = touch.clientY - scroll_start;



                        if (Math.abs(scroll_distance) > 30) {

                            //window.scrollBy(0, scroll_distance * -1);
                            return false;
                        }

                        swipe_distance = touch.clientX - initial_touch;


                    });
                    $(this).on("touchend", function (event) {
                        var touch = event.originalEvent.changedTouches[0];

                        // prevent URLs being followed
//                      event.preventDefault();

                        moved = Math.abs(swipe_distance);

                        if (swipe_distance > 0 && moved > 100) {
                            // swiped to the right...

                            // need to move to the left...
                            scrollPrev.call(prev_bttn);

                        }
                        else if (swipe_distance < 0 && moved > 100) {
                            // swiped to the left...

                            // need to move to the right...
                            scrollNext.call(next_bttn);

                        }
                        else {

                        }

//
                        initial_touch = 0;
                        swipe_distance = 0;
                        moved = 0;
                    });




                },

                autoRotate = function (delay) {
                    var t, // timer
                        d = parseInt(delay),
                        rotate = function () {
                            $(next_bttn).click();
                        },
                        stopAutoRotate = function () {
                            clearInterval(t);
                        },
                        startAutoRotate = function () {
                            if (!isNaN(d)) {
                                t = setInterval(rotate, d);
                            }
                            else {
                                d = 6000;
                                t = setInterval(rotate, d);

                            }
                        };
//

                    $this_carousel.on("mouseenter", function () {
                        stopAutoRotate();
                    });

                    $this_carousel.on("mouseleave", function () {
                        if (!$(next_bttn).attr("data-inprogress") && !$(prev_bttn).attr("data-inprogress")) {
                            startAutoRotate();
                        }
                    });

                    // handle touch
                    if ("ontouchstart" in window) {
                        $this_carousel.on("touchstart", function () {
                            stopAutoRotate();

                        });
                        $this_carousel.on("touchend", function () {
                            if (!$(next_bttn).attr("data-inprogress") && !$(prev_bttn).attr("data-inprogress")) {
                                startAutoRotate();

                            }
                        });

                        // handle the auto-rotate on the button clicks
                        $(next_bttn).on("touchstart", function () {
                            stopAutoRotate();
                        });
                        $(next_bttn).on("touchend", function () {
                            startAutoRotate();
                        });

                        $(prev_bttn).on("touchstart", function () {
                            stopAutoRotate();
                        });
                        $(prev_bttn).on("touchend", function () {
                            startAutoRotate();
                        });
                    }


                    startAutoRotate();
                },

                dotIndicators = function (number_of_items) {
                    console.log("Running dotIndicators...");
                    var indicatorOl = document.createElement("ol"),
                        tmp,
                        i;

                    $(indicatorOl).addClass("carouselx-dotindex");

                    $(indicatorOl).attr("id", $this_carousel.attr("id") + "-dotindex");

                    for (i = 0; i < number_of_items; i++) {
                        tmp = document.createElement("li");

                        if (i === 0) {
                            $(tmp).addClass("current");
                        }

                        indicatorOl.appendChild(tmp);
                    }

                    $this_carousel.after(indicatorOl);
                },

                numberIndicators = function (number_of_items) {
                    console.log("Running numberIndicators...");
                    var indicatorLabel = document.createElement("p"),
                        tmp;

                    $(indicatorLabel).addClass("carouselx-numberindex");

                    $(indicatorLabel).html("<span id=\"" + $this_carousel.attr("id") + "-numberindex\" class=\"carouselx-current-slide\">1</span>/" + number_of_items);

                    $this_carousel.after(indicatorLabel);
                },

                reInit          = function (callback) {

                    // redefine the viewport's width
                    $viewport.width = $viewport.elmnt.outerWidth();


                    // redefine the width_of_item
                    width_of_item = Math.round($viewport.width / view_no);
                    // reset width of each item...
                    $($viewport.elmnt.children("ul").children()).each( function () {
                        $(this).width(width_of_item);
                    });

                    // redefine scroll_length
                    scroll_length = scroll_no * width_of_item;

                    // redefine left_edge for infinite carousels
                    left_edge = scroll_length * -1;

                    // reset the ribbon width
//                  $ribbon.width( width_of_item * no_of_items );

                    $ribbon.width( ($viewport.elmnt.children("ul").children().length * width_of_item) );


                    //... and now redefine the ribbon_length
                    ribbon_length   = $ribbon.width();

                    // redefine max_left
                    max_left = ((ribbon_length - $viewport.width) * -1);


                    // finally set a height for the viewport - because it's needed...
                    $viewport.elmnt.height($ribbon.outerHeight());



                    if (typeof callback === typeof Function) {
                        callback();
                    }
                };

            // init procedures



            // get the viewport...
            $viewport.elmnt = $this_carousel.children("div");
            // what is the width of this viewport?
            $viewport.width = $viewport.elmnt.outerWidth();


            // is this carousel in crossfade mode
            if ($this_carousel.attr("data-crossfade") == "true") {
                xfade = true;
                infinite = true;    // cross fade carousels must be infinite
                view_no = 1;    // cross fade carousels must be 1 slide in view
                scroll_no = view_no;
                $this_carousel.addClass("xfade");   // set the crossfade mode for styling
            }
            // does this carousel specify how many items to view at a time?
            else if ( $this_carousel.attr("data-view") ) {
                view_no = $this_carousel.attr("data-view");
            }

            // ... so each item must be...
                width_of_item = Math.round($viewport.width / view_no);


                // ...so set width on each item
                $($viewport.elmnt.children("ul").children()).each( function () {
                    $(this).width(width_of_item);
                });

            // now... how many items are there?
            no_of_items = $viewport.elmnt.children("ul").children().length;


            // get the ribbon...
            $ribbon = $viewport.elmnt.children("ul");

            // so the ribbon needs to be...
            $ribbon.width( width_of_item * no_of_items );

            // is the scrolling mode is infinite...
            if ($this_carousel.attr("data-infinite")) {
                infinite = true;

            }

            // does this carousel need, and qualify for dot indicators?
            console.log($this_carousel.attr("data-dots"));
            console.log(view_no);

            if (parseInt(view_no, 10) === 1 && $this_carousel.attr("data-dots") == "true") {
                indicators = "dots";
                dotIndicators(no_of_items);
            }
            else if (parseInt(view_no, 10) === 1 && $this_carousel.attr("data-numbers") == "true") {
                indicators = "numbers";
                numberIndicators(no_of_items);
            }

            // scrolling time!

            // does this carousel specify how many items to scroll at a time? - Only if not a cross fade carousel
            if (!xfade) {
                if ( $this_carousel.attr("data-scroll") ) {
                    scroll_no = $this_carousel.attr("data-scroll");

                }
                // else if (view_no) {
                //  scroll_no = view_no;
                // }
            }

            // set values needed for the scroll...
            var ribbon_length   = $ribbon.width(),                              // CONST
                scroll_length   = scroll_no * width_of_item,                    // CONST
                max_left        = (ribbon_length - $viewport.width) * -1,       // CONST
                max_right       = 0;                                            // CONST


            // If this carousel is infinite - we have some logic to work out!
            if (infinite) {
                var $tmp_ribbon = $ribbon.clone(true);

                if (no_of_items % 2 !== 0) {
                    var odd_items = true;

                }
                // else {

                // }

                if (no_of_items <= scroll_no) {

                    $(prev_bttn).css("display", "none");
                    $(next_bttn).css("display", "none");
                }
                // else if (no_of_items == scroll_no) {
                //
                // }
                else {
                    if (no_of_items > scroll_no && no_of_items < (scroll_no * 2)) {


                        var tmp_scroll_no = scroll_no;

                        //if (odd_items) {
                            tmp_scroll_no = no_of_items - view_no;

                        //}

                        // will need to clone the FIRST items to scroll (but MINUS 1) and add them to the end.
                        var first_clones = $tmp_ribbon.children().slice(0, (tmp_scroll_no)).clone(true);





                        first_clones.each( function () {
                            $(this).addClass("clone");
                        });

                        // now have to add these clones to the end of the ribbon!
                        $(first_clones).appendTo($ribbon);

                        // will need to take the LAST items to scroll and add them to the start!
                        var end_clones = $tmp_ribbon.children().slice($tmp_ribbon.children().length - scroll_no).clone(true);

                        end_clones.each( function () {
                            $(this).addClass("clone");
                        });




                        // now add these clones to the START of the ribbon!
                        $(end_clones).insertBefore($ribbon.children("li:first-child"));

                        if (!xfade) {
                            // but wait! adding these to the start will reposition the ribbon - and so start at the wrong item!
                                // so... need to reposition the ribbon to minus 1 scroll length
                            $ribbon.css("left", scroll_length * -1);

                            // redefine the left edge
                            left_edge = parseInt($ribbon.css("left"));
                        }

                            // BUT! now there are more elements so the ribbon length needs to be recalculated and set!
                        var new_ribbon_length = ribbon_length + (first_clones.length * width_of_item) + (end_clones.length * width_of_item);

                        $ribbon.width(new_ribbon_length);
                            // now also give the correct value of the width the the ribbon_length value
                        ribbon_length = new_ribbon_length;



                    }

                    if (no_of_items == (scroll_no * 2)) {


                        var clones = $tmp_ribbon.children().clone(true);

                        // add to the end of the ribbon
                        clones.each( function () {
                            $(this).addClass("clone");
                        });

                        // now have to add these clones to the end of the ribbon!
                        $(clones).appendTo($ribbon);

                        // now move last clones to the front
                        var clones_to_move = $ribbon.children().slice($ribbon.children().length - scroll_no);
                        $(clones_to_move).insertBefore($ribbon.children("li:first-child"));

                        if (!xfade) {
                            // but wait! adding these to the start will reposition the ribbon - and so start at the wrong item!
                                // so... need to reposition the ribbon to minus 1 scroll length
                            $ribbon.css("left", scroll_length * -1);

                            // redefine the left edge
                            left_edge = $ribbon.css("left");
                        }
                            // BUT! now there are more elements so the ribbon length needs to be recalculated and set!
                        var new_ribbon_length = ribbon_length + (clones.length * width_of_item);

                        $ribbon.width(new_ribbon_length);
                            // now also give the correct value of the width the the ribbon_length value
                        ribbon_length = new_ribbon_length;



                    }
                    else if (no_of_items > (scroll_no * 2)) {

                        if (!xfade) {
                            //less_double = true;
                            // need to move the last items in the ribbon to the front
                            var items_to_move = $ribbon.children().slice($ribbon.children().length - scroll_no);
                            $(items_to_move).insertBefore($ribbon.children("li:first-child"));


                            // but wait! adding these to the start will reposition the ribbon - and so start at the wrong item!
                                // so... need to reposition the ribbon to minus 1 scroll length
                            $ribbon.css("left", scroll_length * -1);

                            // redefine the left edge
                            left_edge = $ribbon.css("left");
                        }
                    }

                    if (xfade) {
                        $ribbon.children().slice(1).css("opacity", 0);
                    }
                }
            }

            if ( $this_carousel.attr("data-nextbuttonid") && $this_carousel.attr("data-prevbuttonid")) {
                next_bttn = document.getElementById($this_carousel.attr("data-nextbuttonid"));
                prev_bttn = document.getElementById($this_carousel.attr("data-prevbuttonid"));

                var isDisabled = function( el ) {
                    return (
                        $( el ).attr("data-inprogress") ||
                        $( el ).hasClass("carouselx-disabled")
                    );
                }

                $(next_bttn).on("click", function () {
                    
                    if ( isDisabled( this ) ) { return; }
                //  Otherwise
                    scrollNext.call(this);
                });

                $(prev_bttn).on("click", function () {

                    if ( isDisabled( this ) ) { return; }
                //  Otherwise                    
                    scrollPrev.call(this);
                });
            }

            // finally set a height for the viewport - because it's needed...
            //$viewport.elmnt.height($ribbon.children("li").outerHeight());

            $viewport.elmnt.animate({
                height : $ribbon.children("li").outerHeight()
            }, 250, function () {
                $this_carousel.animate({
                    opacity : 1
                }, 500);
            })
            // $viewport.elmnt.css("opacity", 1);
            /* FX to defeat load flashing */
            //$this_carousel.css("opacity", 0);


            if (no_of_items > view_no) {
                // add touch event handlers
                if ("ontouchstart" in window) {
                    detectSwipe.call($viewport.elmnt);
                }

                if ($this_carousel.attr("data-auto") && infinite) {
                    autoRotate($this_carousel.attr("data-auto"));
                }
            }
            else {
                $(prev_bttn).css("display", "none");
                $(next_bttn).css("display", "none");
            }



            if (mobile)
            {
                $(window).on("resize", function () {

                    var scroll_index = Math.abs(scroll_length / parseInt($ribbon.css("left")));
                    var test_max_left = ((ribbon_length - Math.abs(parseInt($ribbon.css("left")))) <= $viewport.width);
                    var next_left = 0;

                    reInit.call($this_carousel, function () {

                        if (parseInt($ribbon.css("left")) < 0)
                        {
                            if (test_max_left)
                            {
                                $ribbon.css("left", max_left);
                            }
                            else
                            {
                            //  calculate next scroll using the index...
                                next_left = (scroll_length / scroll_index);

                                if ( (next_left * -1) <= max_left )
                                {
                                    $ribbon.css("left", max_left);
                                }
                                else
                                {
                                    $ribbon.css("left", next_left * -1);
                                }
                            }
                        }
                    });
                });
            }

            // if not infinite carousel - need to disable the prev button because it would be at the left edge
            if (!infinite)
            {
                $(prev_bttn).addClass("carouselx-disabled");
            }
        },

        publicInit = function (elm) {
            console.log("publicInit");
            if ( $(elm).find("img").length > 0 ) {
                utils.waitForAllImages($(elm).find("img"), function() {
                    new initCarousel(elm);
                });
            }
        },

    //  Carousel contructor
        ConstructCarousels = function () {
            var $all_carousels  = $("[id|='carouselx']"),
                no_of_carousels = $all_carousels.length,
                i;

            $all_carousels.css({ opacity: 0 });

            // utils.waitForAllImages($("[id|='carouselx'] img"), function () {
            $(window).on("load", function () {
                for (var i = no_of_carousels; i--;) {
                    new initCarousel($all_carousels[i]);
                }
            });
        };


    //  public API
        return {
            version: "1.3",
            about: "The White Company responsive carousel plugin",
            InitCarousel: publicInit,
            Construct: ConstructCarousels
        }

    }()),

//  countdown timer
    countdown = function (count_to, clock_face, countdown_el, callback, tickTockCallback) {     //
        var t,
            MS_PER_DAY = (1000 * 60 * 60 * 24),
            end_time,
            current_time,
            diff_in_time,
            days_left,
            hrs_left,
            mins_left,
            sec_left,
            label,
            regexp_test = /[0-3][0-9]\s[A-z][A-z][A-z]\s[0-9][0-9][0-9][0-9]\,\s[0-2][0-9]\:[0-5][0-9]\:[0-5][0-9]/,
            clock_id,
            this_clock,

        //  private methods
            buildClockDOM = function () {
                var clockface   = document.createElement("ul"),
                    day_box     = document.createElement("li"),
                    day_val     = document.createElement("span"),
                    day_label   = document.createElement("span"),
                    hrs_box     = document.createElement("li"),
                    hrs_val     = document.createElement("span"),
                    hrs_label   = document.createElement("span"),
                    min_box     = document.createElement("li"),
                    min_val     = document.createElement("span"),
                    min_label   = document.createElement("span"),
                    sec_box     = document.createElement("li"),
                    sec_val     = document.createElement("span"),
                    sec_label   = document.createElement("span");

            //  create labels
                day_val.setAttribute("id", "cdclock-" + clock_id + "-daybox");
                day_val.className = "clock-val";
                day_label.appendChild(document.createTextNode("days"));
                day_label.className = "clock-label";
                day_box.appendChild(day_val);
                day_box.appendChild(day_label);

                hrs_val.setAttribute("id", "cdclock-" + clock_id + "-hrsbox");
                hrs_val.className = "clock-val";
                hrs_label.appendChild(document.createTextNode("hours"));
                hrs_label.className = "clock-label";
                hrs_box.appendChild(hrs_val);
                hrs_box.appendChild(hrs_label);

                min_val.setAttribute("id", "cdclock-" + clock_id + "-minbox");
                min_val.className = "clock-val";
                min_label.appendChild(document.createTextNode("minutes"));
                min_label.className = "clock-label";
                min_box.appendChild(min_val);
                min_box.appendChild(min_label);

                sec_val.setAttribute("id", "cdclock-" + clock_id + "-scbox");
                sec_val.className = "clock-val";
                sec_label.appendChild(document.createTextNode("seconds"));
                sec_label.className = "clock-label";
                sec_box.appendChild(sec_val);
                sec_box.appendChild(sec_label);


                clockface.setAttribute("id", "cdclock-" + clock_id);
                $(clockface).addClass(clock_face);

                clockface.appendChild(day_box);
                clockface.appendChild(hrs_box);
                clockface.appendChild(min_box);
                clockface.appendChild(sec_box);

                this_clock = {
                    clock : clockface,
                    day_box : day_box,
                    day_val : day_val,
                    hrs_box : hrs_box,
                    hrs_val : hrs_val,
                    min_box : min_box,
                    min_val : min_val,
                    sec_box : sec_box,
                    sec_val : sec_val
                }
            },

            buildLabel = function () {

                current_time = new Date().getTime();    // ms from 01/01/1970 @ 00:00:00 until RIGHT NOW

                diff_in_time = end_time - current_time;

                if (diff_in_time >= 0) {
                    // calculate number of whole days in the diff
                    days_left = (diff_in_time / MS_PER_DAY);

                    // calculate the numer of hours less than 1 day in the diff
                    hrs_left = (days_left - Math.floor(days_left)) * 24;
                    // console.log("hours : " + hrs_left)

                    // calculate the number of minutes less than 1 hour in the diff
                    mins_left = (hrs_left - Math.floor(hrs_left)) * 60;
                    // console.log("mins : " + mins_left)

                    // calculate the number of seconds less than 1 minute in the diff
                    sec_left = (mins_left - Math.floor(mins_left)) * 60;
                    // console.log("seconds : " + sec_left)

                    days_left = Math.floor(days_left);
                    hrs_left = Math.floor(hrs_left);
                    if (hrs_left.toString().length < 2) {
                        hrs_left = "0" + hrs_left;
                    }
                    mins_left = Math.floor(mins_left);
                    if (mins_left.toString().length < 2) {
                        mins_left = "0" + mins_left;
                    }
                    sec_left = Math.floor(sec_left);
                    if (sec_left.toString().length < 2) {
                        sec_left = "0" + sec_left;
                    }

                    // hide days if not needed
                    if (days_left < 1 && $(this_clock.day_box).is(":visible")) {
                        $(this_clock.day_box).remove();
                    }
                    else {
                        $(this_clock.day_val).text(days_left);
                    }

                    // build string to use
                    //label = days_left + " : " + hrs_left + " : " + mins_left + " : " + sec_left;


                    $(this_clock.hrs_val).text(hrs_left);
                    $(this_clock.min_val).text(mins_left);
                    $(this_clock.sec_val).text(sec_left);


                    //return label;
                }
                else {
                    window.clearInterval(t);
                    // console.log("COOKOOO-COOKOOO!");
                    if (typeof callback === typeof Function) {
                        window.clearInterval(t);
                        callback();
                    }
                }
            },

            tickTock = (function () {
                var ticking = true;

                return function () {
                    if (ticking) {
                        // console.log("tick...");
                        ticking = false;
                    }
                    else {
                        // console.log("tock...");
                        ticking = true;
                    }
                    //$(clock).text(buildLabel());
                    if (typeof tickTockCallback === typeof Function) {
                        tickTockCallback(ticking);
                    }
                    buildLabel();
                }
            }());


        //init
        if (typeof count_to !== typeof "string") {
            return null;
        }
        else if (!regexp_test.test(count_to)) {
            console.log("error! date not provided with full time reference (i.e. DD Mmm YYYY, HH:MM:SS)");
            return null;
        }
        else {
            end_time = new Date(count_to).getTime();    // ms from 01/01/1970 @ 00:00:00 until the chosen date (future)
        }

        if (typeof countdown_el === typeof "string")
        {
            clock = $(countdown_el);
        }
        else if (typeof countdown_el === typeof twc)
        {
            clock = countdown_el;
        }

        clock_id = clock.attr("id");

        if (typeof clock_face !== typeof "string")
        {
            clock_face = "retro";
        }

        buildClockDOM();
        console.log(typeof this_clock);

        clock.html(this_clock.clock);

        // first tick
        tickTock();

        t = window.setInterval(tickTock, 1000);

        $(window).on("unload", function () {
            window.clearInterval(t);
            // alert("interval cleared!");
        });
    },

    revealSlider = (function () {
        var selected_value,
            callbackFn,
            selectSlide = (function () {
                var selected_slide;

                return function (clicked_el) {
                    if (!selected_slide) {
                        $(clicked_el).addClass("selected");
                        selected_slide = clicked_el;

                        if ($(clicked_el).attr("data-value")) {
                            selected_value = $(clicked_el).attr("data-value");
                            if (typeof callbackFn === typeof Function) {
                                callbackFn(selected_value);
                            }
                        }
                    }
                    else if (selected_slide && clicked_el !== selected_slide) {
                        $(selected_slide).removeClass("selected");
                        $(clicked_el).addClass("selected");
                        selected_slide = clicked_el;

                        if ($(clicked_el).attr("data-value")) {
                            selected_value = $(clicked_el).attr("data-value");
                            if (typeof callbackFn === typeof Function) {
                                callbackFn(selected_value);
                            }
                        }
                    }
                    else {
                        // this is already selected
                        console.log("slide already selected");
                        return null;
                    }
                }
        }()),

        // land specific
        setSpecificSlide = function (slide_to_use, $slider_to_mod) {

            $slider_to_mod.children("li[data-value=\"" + slide_to_use + "\"]").trigger("click");
        },

        publicInit = function (slideUl, callback, query_param) {
            var $slider_el = utils.getAsJquery(slideUl),
                param = query_param || "slide",
                query = utils.getQueryParam(param);

            if (!!query) { // if true
                query = query.toLowerCase();
            }
            if (typeof callback === typeof Function) {
                callbackFn = callback;
            }

            $slider_el.children("li").on("click", function () {
                selectSlide(this);
            })

            $(window).on("load", function () {
                if (!query) {
                    // find first current slide
                    $slider_el.children("li.selected").trigger("click");

                }
                else {
                    $slider_el.children("li.selected").removeClass("selected");
                    // setSpecificSlide(query, $slider_el);
                    $("li[data-value=\"" + query + "\"]").trigger("click");
                }
            });




        };

        return {
            version     : "1.0",
            about       : "The White Company slider plugin",
            InitSlider  : publicInit
        }
    }());

    // public API

    return {
        carouselX    : carouselX,
        countdown    : countdown,
        revealSlider : revealSlider
    }
}());

/*

giftFinder module - functionality for the site gift finder page

*/

/**
*
*
* @class giftfinder
*
*/

twc.giftFinder = (function () {
    var cookie_val  = null,
        i,

        // private methods

        loadSelection = function () {
            var $who        = $("#giftwhodd"),
                $what       = $("#giftthemedd"),
                $spend      = $("#pricerangedd");

            if (TwcCookies.read("gf-selection")) {
                cookie_val = TwcCookies.read("gf-selection").split(":");

                for (i = 0; i < cookie_val.length; i++) {
                    switch (cookie_val[i].substring(0, cookie_val[i].search("="))) {
                        case "who":
                            $who.val(cookie_val[i].substring(cookie_val[i].search("=") + 1));
                            $who.trigger("change");
                            break;
                        case "what":
                            $what.val(cookie_val[i].substring(cookie_val[i].search("=") + 1));
                            break;
                        case "spend":
                            $spend.val(cookie_val[i].substring(cookie_val[i].search("=") + 1));
                            break;
                    }
                }
            }
            // else {
//              // no state to load
//
//          }
        },

        saveSelection = function () {
            var $who        = $("#giftwhodd"),
                $what       = $("#giftthemedd"),
                $spend      = $("#pricerangedd"),
                new_cookie = "";

            new_cookie = "who=" + $who.val() + ":what=" + $what.val() + ":spend=" + $spend.val();

            TwcCookies.create("gf-selection", new_cookie, 14);
        };

        return {
            loadSelection   : loadSelection,
            saveSelection   : saveSelection
        }
}());


/**
*
* Builds DOM for peerius recommendations
* @class peerius
*
*/

twc.peerius = (function () {

    /**
    * Builds A list of peerius recommendations
    * @method buildSimilarProducts
    * @param {Object} products - JSON object of product recomendations
    * @param {String} widgetid - widget on the page to place the list in
    */

    var buildSimilarProducts = function (products,widgetid) {

        var product_container = document.createElement("ul"),
            productList,
            links,
            img,
            title,
            priceList,
            priceNow,
            priceWas,
            i,
            productId;

        // Build UL to hold products
        product_container.className = "similar-items";

        // loop through the array of products
        for (i = 0; i < products.length; i++) {

            productList = document.createElement("li");
            product_container.appendChild(productList);

            links = document.createElement("a");
            links.setAttribute("href",products[i].url);
            links.setAttribute("data-productId",products[i].id);
            productList.appendChild(links);

            img = document.createElement("img");
            img.setAttribute("src",products[i].img);
            img.setAttribute("alt",products[i].title);
            links.appendChild(img);

            title = document.createElement("span");
            title.appendChild(document.createTextNode(products[i].title));
            links.appendChild(title);

            priceList = document.createElement("ul");
            links.appendChild(priceList);

            priceNow = document.createElement("li");
            priceNow.className = "unit-price";
            priceList.appendChild(priceNow);

            priceWas = document.createElement("li");
            priceWas.className = "sale-price";
            priceList.appendChild(priceWas);

            if (products[i].prices.GBP.salePrice > 0 && products[i].prices.GBP.unitPrice !== products[i].prices.GBP.salePrice) {
                priceNow.appendChild(document.createTextNode("WAS \u00A3" + products[i].prices.GBP.unitPrice.toFixed(2)));
                priceWas.appendChild(document.createTextNode("NOW \u00A3" + products[i].prices.GBP.salePrice.toFixed(2)));
            } else {
                priceNow.appendChild(document.createTextNode("\u00A3" + products[i].prices.GBP.unitPrice.toFixed(2)));
                priceWas.appendChild(document.createTextNode(""));
            }

            $(links).click (function() {
                    Peerius.smartRecsClick($(this).attr("data-productId"));
                });

        };

        if (document.getElementById(widgetid)) {
            document.getElementById(widgetid).appendChild(product_container);
        }
    };

        return {
            buildSimilarProducts    : buildSimilarProducts
        }
}());


/*
** initPage - depencdencies:
utils.getStyle
*/

/**
*
* Funtions that are run on DOM
* @class initialiseGlobal
*
*/

twc.initialiseGlobal = {

    /* spinbox Functions - maybe not global? */

    /**
    *
    * Detects for input type number support and if not available builds spinbox for older browsers
    * @method spinboxAlternative
    * @deprecated use .spinbox jquery plugin
    */
    spinboxAlternative: function () {
        var q = document.createElement('input'); // create input in memory
        q.setAttribute("type", "number"); // set type to number
        if (q.type !== "number") {  // if the number type is not supported

            // build encapsulation div
            var inputContainer = document.createElement("div"); // create div container - to be copied later
            inputContainer.className = "spinbox-container"; // set container class

            // use DHTML solution for inputs for number
            var increment = document.createElement("img"); // create increment button placeholder - to be copied later
            increment.setAttribute("src", "https://whitecompany.scene7.com/is/image/whitecompany/increment?scl=1&fmt=png-alpha"); // give src - must put in correct URI
            increment.setAttribute("alt", "More"); // give alt text
            increment.className = "spinbox-more"; // give this button a class - used for styling

            var decrement = document.createElement("img"); // create decrement button placeholder - to be copied later
            decrement.setAttribute("src", "https://whitecompany.scene7.com/is/image/whitecompany/decrement?scl=1&fmt=png-alpha"); // give src - must put in correct URI
            decrement.setAttribute("alt", "Less"); // give alt text
            decrement.className = "spinbox-less"; // give this button a class - used for styling

            var sitebody = document.getElementById("page"); // get the 'page' element to look in
            var inputtags = sitebody.getElementsByTagName("input"); // get all inputs within the page div
            for (var i = inputtags.length; i--; ) { // loop through all inputs on the page
                var elmnt = inputtags[i];
                if (elmnt.className === "spinbox") {    // check if element has a class which is exactly 'spinbox' - if so continue
                    var _this = elmnt; // for readability
                    var thisInputParent = _this.parentNode; // get the input's parent element

                    _this.className += " alternative"; // append 'alternative' as class for styling non HTML5 browsers

                    // encapsulate in container div div
                    thisInputContainer = inputContainer.cloneNode(true); // copy the input container div
                    thisInputContainer.setAttribute("id", "spinbox-" + _this.id + ""); // set id for this container

                    var thisIncrement = increment.cloneNode(true); // copy the standard increment button
                    thisIncrement.setAttribute("onclick", "spinboxIncr(\'" + _this.id + "\')"); // give this increment button an onclick event

                    var thisDecrement = decrement.cloneNode(true); // copy the standard decrement button
                    thisDecrement.setAttribute("onclick", "spinboxDecr(\'" + _this.id + "\')"); // give this decrement button an onclick event

                    thisInputContainer.appendChild(_this); // put a copy of this input into the container
                    if (!_this.getAttribute("disabled")) {
                        thisInputContainer.appendChild(thisIncrement); // insert the cloned button into the cloned container
                        thisInputContainer.appendChild(thisDecrement); // insert the cloned button into the cloned container
                    }

                    thisInputParent.appendChild(thisInputContainer); // append this input with the completed spinbox alternative to the parent node

                    // Defeat IE7 bug
                    if (!_this.getAttribute("disabled")) {
                        thisDecrement.parentNode.innerHTML = thisDecrement.parentNode.innerHTML;
                    }
                }
            }
        }
        else {
            return null; // terminate
        }
    },

    /**
    *
    * sets the focus of the enter button for all quantity inputs to the update button
    * @method setFocus
    * @param {Event} event object from event handler
    */

    setFocus: function (e) {
        /*this functions sets the focus of the enter button for all quantity inputs to the update button*/
        if (document.getElementById('tb_order_summary')) {

            var orders = document.getElementById('tb_order_summary'),
                inputs = orders.getElementsByTagName('input');

            for (var i = 0; i < inputs.length; i++) {

                if (inputs[i].className === "spinbox" || inputs[i].className === "spinbox alternative") {
                    inputs[i].onkeypress = setEnter;
                }
            }
        }

        function setEnter(e) {

            e = e || window.event;

            if (e.keyCode == 13) { //enterKey pressed
                if (!e.preventDefault) {
                    e.returnValue = false;
                } else {
                    e.preventDefault();
                }
                document.getElementById("in_btnUpdatCart").click();
            }
        }
    },

    /**
    * sets the focus of the enter button to the payment button
    * @method setEnterFocusPayment
    * @param {Event} event object from event handler
    */


    setEnterFocusPayment: function(e) {

        if (document.getElementById('in_txtCardNumber')) {
            var cardNumber = document.getElementById('in_txtCardNumber');
            var cardHolderName = document.getElementById('in_txtHolderName');
            var issueNumber = document.getElementById('in_issueNo');
            var cv2 = document.getElementById('in_cscCode');

            var cardInputs = [cardNumber, cardHolderName, issueNumber, cv2];

            for (var i = 0; i < cardInputs.length; i++) {

                cardInputs[i].onkeypress = function (e) {

                     e = e || window.event;

                    if (e.keyCode == 13) { //enterKey pressed
                        if (!e.preventDefault) {
                            e.returnValue = false;
                        } else {
                            e.preventDefault();
                        }
                        try {
                            document.getElementById("in_btnPay").click();
                        } catch (err) {
                            document.getElementById("in_btnPay").focus();
                        }
                    }
                }
            }
        }

    },

    /**
    * Loads image in checkout when confirming order... Disables confirm order button to prevent double submission of form
    * @method loadingImage
    */

    loadingImage: function () {
        // load image in checkout when confirming order
        // disable button to prevent double submission of order
        if (document.getElementById('in_btnPay')) {

            var documentHeight = $(document).height();

            var whiteOut          = document.createElement('div'),
                whiteOutContainer = document.createElement('div'),
                paragraph         = document.createElement('p'),
                loadingImage      = new Image();

            loadingImage.src = "/images/spinner.gif";

            loadingImage.setAttribute("id" , "img_processing");
            loadingImage.setAttribute("alt" , "processing");
            loadingImage.className = "block-center pad-bottom-12px";
            loadingImage.setAttribute("width" , "32");
            loadingImage.setAttribute("height" , "32");

            whiteOutContainer.className = "pos-abs text-center width-fit";
            whiteOutContainer.setAttribute("id" , "processingContainer");
            whiteOutContainer.setAttribute("style" , "top:0; display:none; z-index:10; height:" + documentHeight + "px");

            whiteOut.className = "pos-abs width-fit";
            whiteOut.setAttribute("style" , "background-color:#fff; opacity:0.8; height:100%");

            whiteOutContainer.appendChild(whiteOut);
            paragraph.appendChild(loadingImage);

            copy = document.createTextNode("Your order is being processed. Please do not refresh this page.");
            paragraph.appendChild(copy);

            paragraph.className = "width-fit bold-txt timesnewroman";
            paragraph.setAttribute("style", "z-index: 10; position: fixed; top: 50%; font-style: italic; font-size: 14px");

            whiteOutContainer.appendChild(paragraph);

            $('body').append(whiteOutContainer);

            var confirmOrder = document.getElementById('in_btnPay');

            $(confirmOrder).on("click", function (event) {

                if ($(".error-msg:visible").length === 0) {
                    whiteOutContainer.style.display = "block";

                }

            });

            $(confirmOrder).on("dblclick", function (event) {

                event.preventDefault();

            });
        }
    },

    /**
    * validates serach input before submitting the search in the header
    * @method submitSearch
    */

    submitSearch: function () {

        if (!document.getElementById('in_site_search_button')) { return; }
        var searchButton = document.getElementById('in_site_search_button');

        searchButton.onclick = function (e) {
            e = e || window.event;
            if (!e.preventDefault) {
                e.returnValue = false;
            } else {
                e.preventDefault();
            }

            var searchString = document.getElementById('in_site_search');
            var searchInput = searchString.value;
            var validateSearch = ACC.searchSuggestSpecialCharacterValidationPattern;
            var isAllowed = Boolean(searchInput) && searchInput.length >= ACC.autocompleteMinChars && !validateSearch.test(searchInput);

            if (isAllowed) {
                // remove '&' from search value when submitting form (FHI-144)
                searchString.value = searchString.value.replace(/( &)/,'');

            //  UK: '/search/' + searchInput;
            //  Note: this is a potential place for the functionality to break if they change the URL scheme
                // document.location = '/search?text=' + searchInput;
            //  Could be much better to have the form post itself, OK fine, let's :)
                document.getElementById('formSearch').submit(); // MUCH better
            } else {
                document.getElementById('searchError').style.display = 'block';
            }
        }
    },

    /**
    * Focus the enter button to the join button
    * @method setEnterkeyEmail
    */

    setEnterKeyEmail: function() {

        var emailInput = document.getElementById('in_EmailToSubscribe');
        if(document.getElementById('in_EmailToSubscribe')){
            emailInput.onkeypress = function(e) {

                e = e || window.event;
                if (e.keyCode == 13) { //enterKey pressed
                    if (!e.preventDefault) {
                        e.returnValue = false;
                    } else {
                        e.preventDefault();
                    }
                    subscribe();
                }
            }
        }

    },

    /**
    * Focus the enter button to the correct button on postcode lookup
    * @method setEnterPostcode
    */

    setEnterPostCode: function() {

        if (document.getElementById('in_btnPostCodeSearch')) {
            var lookup = document.getElementById('in_txtPostCd') || document.getElementById('txtPostCodeGB');
            var lookupButton = document.getElementById('in_btnPostCodeSearch');

            lookup.onkeypress = function(e) {
                e = e || window.event;
                if (e.keyCode == 13) { //enterKey pressed
                    if (!e.preventDefault) {
                        e.returnValue = false;
                    } else {
                        e.preventDefault();
                    }
                    lookupButton.click();
                }
            }
        }
    },

    /**
    * Focus the enter button to the correct button on postcode lookup
    * @method collapsingBoxes
    * @deprecated use the new drawers one
    */

    collapsingBoxes: function () {

        // object constructor
        var Detailsbox = function (element) {
            this.element=element;
        }

        // array to store all collapsible elements
        var boxesArray = [];

        // check method to get elements
        if (!document.querySelectorAll) {
            //
            var detailsboxes=$("[id|=collapse]");
        }
        else {
            //
            var detailsboxes=document.querySelectorAll("[id|=collapse]");
        }
        //

        // if boxes found on page...
        if (detailsboxes.length > 0) {

            // create UI widgets - to be cloned for use
            var togglebutton=document.createElement("div");
            togglebutton.className="pos-rel";

            var innertogglebutton=document.createElement("div");
            innertogglebutton.className="expand-button";

            var buttonText=document.createTextNode("+");

            innertogglebutton.appendChild(buttonText);

            togglebutton.appendChild(innertogglebutton);

            // get all elements to be used as collapsible boxes and add them to the array as objects
            for (var i=detailsboxes.length; i--;) {
                boxesArray.push(new Detailsbox(detailsboxes[i]));
            }

            // add functionality to all relevant elements
            for (var i=0; i<boxesArray.length; i++ ) {

                //

                (function(i) {  // JS closure START
                    var thisBox = boxesArray[i].element;

                    if (!thisBox.getAttribute('data-collapsedheight')) {
                        //
                        return null;
                    }

                    // get the desired expanded and collapsed height settings

                    //
                    if (!thisBox.getAttribute('data-expandedheight')) {
                        //
                        for (var i=0,length=thisBox.children.length;i<length;i++) {
                            if (thisBox.children[i].nodeType !== 1) {
                                continue;
                            }
                            else {
                                var expandedHeight=$(thisBox.children[i]).height();
                                //
                                break;
                            }
                        }
                    }
                    else {
                        var expandedHeight=thisBox.getAttribute('data-expandedheight');
                    }

                    var collapsedHeight=thisBox.getAttribute('data-collapsedheight');
                    var button=togglebutton.cloneNode(true);
                    thisBox.insertBefore(button,thisBox.firstChild);

                    utils.addListener(button.firstChild, 'click', function () {

                            if (parseInt(utils.getStyle(thisBox, 'height')) < expandedHeight) {
                                thisBox.style.height=expandedHeight+"px";
                                button.firstChild.innerHTML="&minus;";
                            }
                            else {
                                thisBox.style.height=collapsedHeight+"px";
                                button.firstChild.innerHTML="+";
                            }
                        });
                })(i);  // JS closure END - makes sure i2 is never stuck as the last value by making i2 a static value
            }
        }
    },

    /**
    * Sets the position of the tracking image in the header to absolute to remove the gap it causes in the header
    * @method tempRemoveTopGap
    */

    tempRemoveTopGap: function () {
        var allImages=document.images;
        var adsImgUrl=/googleadservices/i;
        for (var i=0; i<allImages.length; i++) {
            if (adsImgUrl.test(allImages[i].src)) {
                if (allImages[i].width===1) {
                    allImages[i].style.position="absolute";
                    break;
                }
            }
        }
    },

    /**
    * Remove not used
    * @method buildPopUpTandCs
    * @deprecated needs to be removed
    */

    buildPopUpTandCs: function () {
        var showTerms,
            pop_up_trigger  = document.getElementById("popupterms"),
            info_box        = document.getElementById("div_termstext"),
            dismiss_button  = document.createElement("div");

        if (pop_up_trigger) {
            // add dismiss button
            dismiss_button.setAttribute("alt", "close");
            dismiss_button.setAttribute("id", "div_dismisspopup");

            // attach listener to the finished button
            utils.addListener(dismiss_button, "click", function () {
                //info_box.style.display = "none";
                $(info_box).fadeOut();
            });

            info_box.insertBefore(dismiss_button, info_box.firstChild);

            utils.addListener(pop_up_trigger, "click", function (e) {

                e = e || window.event;

                if (!e.preventDefault) {
                    e.returnValue = false;
                } else {
                    e.preventDefault();
                }

                //info_box.style.display = "block";
                $(info_box).fadeIn("fast");
            });
        }
    },

    /**
    * Sets the width of html buttons for ie7
    * @method adjustHTMLButtons
    */

    adjustHTMLButtons: function () {
        var ie_7_id = "MSIE 7",
            user_agent = navigator.userAgent;

        if (user_agent.indexOf(ie_7_id) !== (-1)) {
            $("div[class|=button]").each(function () {
                $(this).css("width", $(this).outerWidth());
            });
        }
    },

    /**
    * Sets the selected class for the current active navigation deperment
    * @method initNav
    */


    initNav: function () {
        var umbrella_container = document.getElementById("umbrellas"),
        blackout = document.createElement("div");

        (function () {
            var url_path = location.pathname,
                url_ands = /\-and\-/g,
                hyphens = /\-/g,
                main_section = url_path.substr(1,(url_path.indexOf("/",1)-1)),
                site_nav = document.getElementById("umbrellas");

            try {
                if (url_ands.test(main_section)) {
                    main_section = main_section.replace(url_ands, "-");
                }
                else {
                    if (hyphens.test(main_section)) {
                        main_section = main_section.replace(hyphens, "");
                    }
                }

                // now select the correct li

                if (!!main_section) {
                    document.getElementById("nav-" + main_section).className = "selected";
                }
            }
            catch (err) {
                // do nothing
            }
        })();

        blackout.setAttribute("id", "div_screen");
        blackout.style.height = (document.documentElement.scrollHeight) + "px";

        document.body.appendChild(blackout);

        if ("ontouchstart" in window) {
                                $("#div_screen").click(function () {
                                    $("#div_screen").fadeOut();
                                    $("#umbrellas").removeClass("nav-active");
                                });
                            }

        $(umbrella_container).removeClass("no-js");

        $(umbrella_container).hoverIntent(
            function () {
                $(blackout).css('filter', 'alpha(opacity=15)'); // has to be reapplied for IE8 flicker issue
                $(blackout).stop(true, true).fadeIn(250);
                // Windows UI override
                $("#ddlSort").css("display", "none");
                $("#sl-sizes").css("display", "none");
                $(".clothing-dropdown").css("display", "none");
                // End override
                $(this).addClass("nav-active");
            },
            function () {
                $(blackout).stop(true, true).fadeOut();
                // Windows UI override
                $("#ddlSort").css("display", "inline-block");
                $("#sl-sizes").css("display", "inline-block");
                $(".clothing-dropdown").css("display", "inline-block");
                // End override
                $(this).removeClass("nav-active");
            }
        );

        /* $("#umbrellas > li").mouseover(
            function (event) {
                if (this.getAttribute("id") === "nav-inspireme") {
                    $(blackout).css({
                        "opacity" : "0",
                        "filter"  : "alpha(opacity=0)"
                    });
                }
                else {
                    $(blackout).css({
                        "opacity" : "0.15",
                        "filter"  : "alpha(opacity=15)"
                    });
                }
            }
        ); */
    },

    /**
    * Removes the US cookie when the usflag is clicked
    * @method removeUsCookie
    */


    removeUsCookie: function () {
        $(".usflag").on("click", function(){
            TwcCookies.erase("redirectToUS");
        });
    },

    /**
    * Flyout for when the flag in the header is clicked to confirm action
    * @method flagMessage
    *
    */

    flagMessage: function() {
        $(".usflag").on("click", function (event) {
            event.preventDefault();

            var container = document.createElement("div"),
                screen = document.createElement("div"),
                msg_container = document.createElement("div"),
                msg_p = document.createElement("p"),
                msg_txt = document.createTextNode("You are about to leave the UK site and go to the US site. Are you sure you want to continue?"),
                continue_bttn = document.createElement("a"),
                cancel_bttn = document.createElement("span");

            screen.setAttribute("id", "flag-screen");
            screen.className = "screen pos-abs width-fit";
                $(screen).css({
                    "height" : $(document.body).height(),
                    "width" : "100%",
                    "background-color" : "#000",
                    "opacity" : "0.5",
                    "filter" : "alpha(opacity=50)",
                    "z-index" : "500",
                    "overflow" : "hidden",
                    "top" : "0",
                    "left" : "0"
                });

            document.body.appendChild(screen);

            container.setAttribute("id", "flag-message");
                $(container).css({
                    "height" : $(document.body).height(),
                    "width" : "100%",
                    "z-index" : "500",
                    "overflow" : "hidden",
                    "position" : "absolute",
                    "top" : "0",
                    "left" : "0"
                });

                $(msg_container).css({
                    "margin" : "auto",
                    "margin-top" : "16.5%",
                    "background": "#fff",
                    "border": "1px solid #dadada",
                    "padding": "20px",
                    "width": "400px"
                });

                $(msg_p).css({
                    "color": "#666",
                    "font-size": "12px",
                    "line-height": "14px",
                    "margin": "0 0 12px 0",
                    "word-wrap": "break-word",
                    "-ms-word-wrap": "break-word"
                });

            msg_p.appendChild(msg_txt);

            continue_bttn.setAttribute("href", "https://www.thewhitecompany.com/us");
            continue_bttn.appendChild(document.createTextNode("continue"));
            continue_bttn.className = "button-full primary-black";

            cancel_bttn.appendChild(document.createTextNode("cancel"));
            cancel_bttn.className = "button-halo secondary mar-left-12px";

            msg_container.appendChild(msg_p);
            msg_container.appendChild(continue_bttn);
            msg_container.appendChild(cancel_bttn);

            container.appendChild(msg_container);

            document.body.appendChild(container);

                $(cancel_bttn).on("click", function () {
                    $("#flag-screen").remove();
                    $("#flag-message").remove();
                });
        });
    }/*,

    searchSuggestions : function () {

        var startSearch = function () {
            $.ajax({
                  url: "/searchsuggestion.aspx",
                  dataType: "json",
                  success: function( responseData ) {

                    var data = responseData.SearchLists.map(function(elem) {

                            return elem.label;

                        });



                    $("#div_site_search").off("focus", "#in_site_search", startSearch);

                    $( "#in_site_search" ).autocomplete({
                      source: data,
                      minLength : 4,
                      select: function (event, ui) {

                        $(this).val(ui.item.value);
                        $("#in_site_search_button").trigger("click");
                      }
                    });

                  }

            });
        };

        $("#div_site_search").on("focus", "#in_site_search", startSearch);
    }*/

}; // End twc.initialiseGlobal

//add to array so that functions can be called on domready
twc._onReady.push('initialiseGlobal');

/**
*
* validates input value of quantity inputs
* @method validateAsNumber
* @param {Object} input DOM element
* @deprecated
* @for window
*/

function validateAsNumber(elmnt) {
    var q=elmnt;                            // capture the input to validate
    var regExTest=/\D/i;                    // regexp to look for a non-digit character
    var thisValue=regExTest.test(q.value);  // test value of input for non-digit character
    if (thisValue) {                        // thisValue true - i.e. non-digit character found
        q.value=1;                          // set value to 1
    }
    if (q.value > 99) {
        q.value=99;
    }
}

/**
* Increments quanity input
* @method spinboxIncr
* @param {String} id - DOM element
* @deprecated
* @for window
*/

function spinboxIncr(id) {
    var inputElmnt=document.getElementById(id); // get element using the id that was passed to the function - see spinboxAlternative function
    var currentVal=inputElmnt.value;    // get the current value of that input
    if (currentVal < 99) {
        currentVal++;   // increment that value
        inputElmnt.value=currentVal;    // set the input to the new value
    }
    else {
        return null;
    }
}

/**
* Decrements quantity input
* @method spinbodDecr
* @param {String} id - DOM element
* @deprecated
* @for window
*/

function spinboxDecr(id) {
    var inputElmnt=document.getElementById(id); // get element using the id that was passed to the function - see spinboxAlternative function
    var currentVal=inputElmnt.value;    // get the current value of that input
    if (currentVal > 0) {   // if the current value is greater than 0 - proceed
        currentVal--;   // decrement current value
        inputElmnt.value=currentVal;    // set the input to the new value
    }
    else {
        return null;    // terminate
    }

}

/* End spinbox Functions */

/* Tabs (component/snippet)

    Enables tabbing function on tabs components/snippets

** Usage: selectTab("idOfTabsContainer") || selectTab(TabsObj)
    The function can be called in 2 ways either by passing the id string of the tabs element that needs enabling or if you have already captured this element as a variable (i.e. object) then passing the object itself

** selectTabs() dependencies:
    getEvent()
*/


/**
* sets active and inactive states of the tabs
* @method selectTab
* @param {String} id - DOM element
* @for window
*/


function selectTab(container) {
    if (typeof container!="object") {
        var container=document.getElementById(container);   // get container list for tabs
    }
    container.onclick=function (e) {
        var target=getEvent(e,"target");
        var clickedOn=target.nodeName.toLowerCase();
        if ( (clickedOn === "li" || clickedOn === "h2") && (target.getAttribute("data-valid")==="true")) {  // ensures only valid tabs are clickable
            // stop propagation/bubbling here?
            var allTabs=container.getElementsByTagName("li");   // get this tabs parent - the whole list
            for (var c=allTabs.length; c--;) {  // for loop in reverse for speed
                if (allTabs[c].getAttribute("data-valid")==="true") {
                    allTabs[c].className="";    // remove class from all the tabs
                }
            }
            if (clickedOn==="h2") {
                target.parentNode.className="selected-tab";
            }
            else {
                target.className="selected-tab";    // add selected-tab class to only this tab
            }
        }
    }
}
/* END Tabs */


/**
* Functions to handle cookies
* @class TwcCookies
*/

var TwcCookies = {

    /**
    *
    *   create('mobile','true',7);
    *   read('mobile');
    *   erase('mobile');
    *
    */

    /**
    * Creates a cookie with a given name, value and expirary date
    * @method create
    * @param {String} name
    * @param {String} value
    * @param {Number} days
    */

    create: function (name, value, days) {

        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            var expires = "; expires=" + date.toGMTString();
        }
        else {
            var expires = "";
        }
        document.cookie = name + "=" + value + expires + "; path=/";
    },

    /**
    * Reads a cookie
    * @method read
    * @param {String} name
    */

    read: function (name) {

        var nameEQ = name + "=";
        var ca = document.cookie.split(';');

        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },

     /**
    * Deletes a cookie
    * @method erase
    * @param {String} name
    */

    erase: function (name) {
        this.create(name, "", -1);
    }

};

/**
* @method resetLookCookie
* @deprecated not used anymore
*/

// function for cookie creation
function resetLookCookie() {
    var exDt=new Date();
    exDt.setDate(exDt.getDate()+10);
    document.cookie="look=1;expires="+exDt+";path=/";
}

/** Form validation **/
/**
    * usage
    * The passed object is a list of all input fields that need validating

    var collectPlusValidate = new twc.validateForm();
    collectPlusValidate.initialise(
        {fields: [
            {id : "fName", type : "text", errMessage : "invalid"},
            {id : "lName", type : "text", errMessage : "invalid"}
        ]}
    );

    $("#in_btnProceed").on("click", function(event){
        collectPlusValidate.doCheck(event);

    });

**/


/**
*
* Written to validate forms used in checkout for collectplus
* @class validateForm
*
*/


twc.validateForm = function () {

    // Private methods

    var isInt = function(elementId){

    };

    /**
    *
    * Validate email address
    * @method isEmail
    * @param {String} elementId - id of input to be validated
    * @param {Boolean} isOptional - is the input mandatory
    * @return boolean
    * @private
    */

    var isEmail = function(elementId, isOptional) {
        // Expression is from standards RFC 2822
        var validEmail = /[a-z0-9!#$%&'*+\/=?^_'{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_'{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;

        if (isOptional && isEmpty(elementId)) {
            return true;
        } else {
            return validEmail.test($("#" + elementId).val());
        }
    }

    /**
    *
    * Validate phone number
    * @method isPhone
    * @param {String} elementId - id of input to be validated
    * @param {Boolean} isOptional - is the input mandatory
    * @return boolean
    * @private
    */

    var isPhone = function(elementId, isOptional) {

        // remove all empty spaces
        var phoneNumber = $("#" + elementId).val().replace(/ /g,'');

        // replace +44 and 0044 with just 0
        var phoneNumber = phoneNumber.replace(/^(\+44|0044)/, "0");

        // valid phone number starts with
        var validPhoneNumber = /07\d{9}/;

        // set the input field to cleaned number
        $("#" + elementId).val(phoneNumber);

        if (isOptional && isEmpty(elementId)) {
            return true;
        }  else if(phoneNumber.length > 11) {
            return false;
        } else {
            return validPhoneNumber.test(phoneNumber);
        }

    }

    /**
    *
    * Validate email address
    * @method isEmpty
    * @param {String} elementId - id of input to be validated
    * @return boolean
    * @private
    */

    var isEmpty = function (elementId) {

        if ($("#" + elementId).val() === "") {
            return true;
        }
        else {
            return false;
        }
    }

    /**
    *
    * Runs the validation depending on the type of input
    * @method doCheckOne
    * @param {String} aInput - id of input to be validated
    * @return boolean
    * @private
    */


    var doCheckOne = function (aInput) {

        switch (aInput.type) {

            case "email" :

                if (!isEmail(aInput.id, aInput.optional)) {
                    createErrorMessage(aInput.id, aInput.errMessage);
                } else {
                    clearErrMesssage(aInput.id);
                }
                break;

            case "phone" :

                if (!isPhone(aInput.id, aInput.optional)) {
                    createErrorMessage(aInput.id, aInput.errMessage);
                } else {
                    clearErrMesssage(aInput.id);
                }
                break;

            default:

                if (isEmpty(aInput.id)) {
                    createErrorMessage(aInput.id, aInput.errMessage);
                } else {
                    clearErrMesssage(aInput.id);
                }
        } // end switch
    };

    /**
    *
    * Creates an error message after the invalid input
    * @method createErrorMessage
    * @param {String} aInput - id of input to be validated
    * @param {String} errorMessage - error message to be displayed
    * @private
    */

    var createErrorMessage = function (elementId, errorMessage) {

        var $errorInput = $("#" + elementId);
        $errorInput.css("border", "1px solid red");
        $errorInput.after("<span class='cplus-error red'>" + errorMessage + "</span>");
    };

    /**
    *
    * Resets and removes all form errors
    * @method resetFormErrors
    * @param {String} inputsObject - all inputs that are in the form
    * @private
    */

    var resetFormErrors = function (inputsObject) {

        // remove all error messages
        $(".cplus-error").remove();

        // loop through all validation fields as specified in object and reset border colour
        for (i=0; i < inputsObject.fields.length; i++){
            $("#" + inputsObject.fields[i].id).css("border", "1px solid #DADADA");
        }

    };

    /**
    *
    * Clears the error message, removes it from the DOM
    * @method clearErrMessage
    * @param {String} elementId - id of the input
    * @private
    */

    var clearErrMesssage = function (elementId) {

        var $input =  $("#" + elementId);

        $input.css("border", "1px solid #DADADA");
            if ($input.next("span").hasClass("cplus-error")){
                $input.next("span").remove();
            }

    };

    // Public Methods

    /**
    * Attaches onblur event handler to supplied inputs
    * @method initialise
    * @param {Array} fieldsToValidate - array of input fields DOM elements
    */

    this.initialise = function (fieldsToValidate) {

        this.fieldsToValidate = fieldsToValidate;

        var _self = this;

        for (i=0; i < this.fieldsToValidate.fields.length; i++){

            (function (i) {

                $("#" + _self.fieldsToValidate.fields[i].id).on("blur", function(){

                    if ($("#" + _self.fieldsToValidate.fields[i].id).next("span").hasClass("cplus-error")){
                        $("#" + _self.fieldsToValidate.fields[i].id).next("span").remove();
                    }

                    doCheckOne(_self.fieldsToValidate.fields[i]);

                });

            })(i);
        }
    };

    /**
    *
    * Runs doCheckOne on all inputs after resetting all the form errors if there were any
    * @method doCheck
    * @param {Event} event - takes the event object
    */

    this.doCheck = function (event) {

    // Check all inputs on click of submit

        // reset form errors
        resetFormErrors(this.fieldsToValidate);

        // loop through all inputs

        for (var i=0; i < this.fieldsToValidate.fields.length; i++){

            doCheckOne(this.fieldsToValidate.fields[i]);

        } // End For

        // if there are errors prevent form submission

        if ($(".cplus-error").length > 0) {
            event.preventDefault();
        }

    }; // doCheck()

}; // End TWC.validateCollectPlus

/* Collapsing Boxes 2

    * for use only in checkout for now.
    * use as a callback for function to text use cases - checkout function is 'boxesTest()'
    * usage:
    * boxesTest(twc.collapsingBoxes2);
*/

/**
*
* Accordian plugin
* @class collapsingBoxes2
*
*/


twc.collapsingBoxes2 = function () {
    //  variables
    var details_boxes = $("[id|=collapse2]"),   // get all boxes that are flagged as collapsible boxes
        no_of_boxes = details_boxes.length,
        i,
        tmp_widget,
        widget = document.createElement("span"),

    /**
    *
    * Add click event handler to supplied elements
    * @addWidgetListener
    * @param {Object} box_to_work_on - DOM element
    * @private
    */

    //  private methods
        addWidgetListener = function (box_to_work_on) {

            $(this).click( function () {

                $(box_to_work_on).children("div").slideToggle("medium", function () {
                    if ($(this).css("display") === "none") {
                        $(box_to_work_on).addClass("closed");
                    }
                    else {
                        $(box_to_work_on).removeClass("closed");
                    }
                });
            });
        };

    // function body
    if (no_of_boxes > 0) {
        for (i = 0; i < no_of_boxes; i++) {
            tmp_widget = widget.cloneNode(true);
            tmp_widget.className = "widget";
            addWidgetListener.call(tmp_widget, details_boxes[i]);
            $(details_boxes[i]).children("span").append(tmp_widget);
            if (details_boxes[i].hasAttribute("data-initialclosed")) {
                $(details_boxes[i]).children("div").toggle();
                $(details_boxes[i]).addClass("closed");
            }
        }
    }

    twc.collapsingBoxes2 = function () {
        // redefine function to do nothing
        return null;
    };
}; // End twc.collapsingBoxes2

/**
*
*
* Definitions of a global add to bag function used accross all pdp and feature pages
* @class shop
*
*/

// 2014 modules
twc.shop = (function () {
    var globalAddToBag = (function () { // globalAddToBag.pdp("#feedback"))
        var // common/constansts
            add_to_bag_data,
            feedback,
            add_to_bag_url  = "/addtobagapi.aspx",
            $qty_inputs,
            items_added_count,
            price_added_sum,
            chkout = false,

            // functions to get/manipulate Qtys

            pdp_qtys = function () {
                $qty_inputs = ($("li.qty-column [name='in-quantities']").length !== 0) ? $("li.qty-column [name='in-quantities']") :
                                ($("li.select-qty-dropdown [name='in-quantities']").length !== 0) ? $("li.select-qty-dropdown [name='in-quantities']") : $(".twc-spinbox-quantity");
            },

            dpw_qtys = function () {
                $qty_inputs = ( $("#sl-pop-up-qty").length !==0 ) ? $("#sl-pop-up-qty") : $(".twc-spinbox-quantity");
            },

            resetQtys = function () {
                $qty_inputs.val("0").trigger("change");
            },


            // functions to use as callbacks or for interactions
            updateMiniBasket = function () {
                var current_basket_count    = parseInt(document.getElementById("lblItemCount").firstChild.nodeValue),
                    current_basket_total    = document.getElementById("ltotal").firstChild.nodeValue.replace(/[^0-9\.]/, ""),
                    comma                   = /\,/,

                    // private methods

                    formatMiniBasketTotal   = function (total_to_format) {
                        var new_total = (total_to_format.toFixed(2)).toString(),
                            no_of_digits = new_total.slice(0, new_total.search(/\./)),
                            pre_comma,
                            post_comma,
                            formatted_total;

                        if (no_of_digits.length >= 4) {

                            pre_comma = new_total.slice(0, no_of_digits.length - 3);

                            post_comma = new_total.slice(no_of_digits.length - 3);

                            formatted_total = pre_comma + "," + post_comma;
                        }
                        else {
                            formatted_total = new_total;
                        }

                        return formatted_total;
                    };

                // remove comma's if any from the current_basket_total
                if (comma.test(current_basket_total)) {
                    current_basket_total = current_basket_total.replace(",", "");
                }

                current_basket_total = parseFloat(current_basket_total);

                // calculate new basket count
                new_basket_count = current_basket_count + items_added_count;
                new_basket_price = current_basket_total + (price_added_sum);

                // update the mini basket
                $("#lblItemCount").empty().html(new_basket_count);
                $("#ltotal").empty().html("&pound;" + formatMiniBasketTotal(new_basket_price));
            },

            // showSpinner = function (bttn_el) {
            //  var $bttn = utils.getAsJquery(bttn_el);

            //  // $(".bttn-add-to-bag").fadeOut("fast", function () {
            //  //  // dynamically add the spinner
            //  // });
            // console.log("ADDING TO BAG...");
            //  $bttn.css({
            //      "border-color" : "#FFF"
            //  });
            //  $bttn.html("<img src=\"/images/spinner.gif\" alt=\"adding item to bag\">");
            // },

            showSpinner = function (bttn_el) {
                var $bttn = utils.getAsJquery(bttn_el);

            console.log("ADDING TO BAG...");
                $bttn.fadeOut(200, function () {
                    if ($bttn.parent().children(".pdp-spinner").length !== 0) {
                        $bttn.parent().children(".pdp-spinner").fadeIn(200);
                    }
                    else {
                        $bttn.before("<img class=\"pdp-spinner\" src=\"/images/spinner.gif\" alt=\"adding item to bag\">");
                    }
                });
            },

            // hideSpinner = function (bttn_el) {
            //  // $("#img-spinner").fadeOut(200);
            //  // $(".bttn-add-to-bag").fadeIn(200);
            //  var $bttn = utils.getAsJquery(bttn_el);

            //  console.log("ADD TO BAG COMPLETE...");
            //  $bttn.css({
            //      "border-color" : "#000"
            //  });
            //  $bttn.text("add to bag");
            // },

            hideSpinner = function (bttn_el) {
                var $bttn = utils.getAsJquery(bttn_el);

                $bttn.parent().children(".pdp-spinner").fadeOut(200, function () {
                    $bttn.fadeIn(200);
                });
            },


            // logic functions

            processQtys = function () {
//  TODO: optimise this, there are numerous calls to jQuery objects for simpler values
                var string_data     = "";

            //  reset count and sum vars
                items_added_count   = 0;
                price_added_sum     = 0;

                $qty_inputs.each(function () {
                    if (parseInt($(this).val(),10) !== 0) {
                        if (string_data !== "") {
                            string_data += ";";
                        }
                        string_data += $(this).attr("data-sku") + "," + $(this).val();  /* + "," + window.location.href */

                        // update price sums and qty counts
                        items_added_count   = items_added_count + parseInt($(this).val(), 10);
                        price_added_sum     = price_added_sum + (parseFloat($(this).attr("data-price").replace(/[^0-9\.]/, "") * $(this).val()));
                    }
                });

                console.log(string_data);
                add_to_bag_data = { apibasket: string_data };
                console.log(add_to_bag_data);

            },

            postRequest = function (bttn_el, callback) {

                $.post(add_to_bag_url, add_to_bag_data).done(function (data) {
                        var fb_msg = "Your item(s) have been added to the shopping bag";
                        // reset all qty boxes
                        resetQtys();

                        // display feedback message

                        // detect if one item or multiple has just been added and change feedback message accordingly

                        feedback.empty();
                        if (document.getElementById("add-to-bag-extra")) {
                            $("#TopAddMessage1-b").empty();
                        }

                        feedback.text(fb_msg);
                        if (document.getElementById("add-to-bag-extra")) {
                            $("#TopAddMessage1-b").text(fb_msg);
                        }

                        // $("#sl-pop-up-qty").val(0);
                        // twc.cms.add_to_bag.qty = 0;
                        // $("#img-spinner").fadeOut("fast");
                        // $(button).fadeIn("fast");

                        // trigger mini basket update

                        hideSpinner(bttn_el);
                        if (document.getElementById("add-to-bag-extra")) {
                            console.log("extra button found");
                            hideSpinner("#add-to-bag-extra");
                            $("#TopAddMessage1-b").text($("#add-to-basket-message").text());
                        }

                        updateMiniBasket();

                        if (typeof callback === typeof Function) {
                            callback();
                        }
                        if (chkout) {
                            window.location.assign("/shopping-bag/");
                        }
                    })
                    .fail(function () {
                        var fb_msg = "<span class=\"error-msg\">Sorry, an error occured and your items could not be added to your bag - please try again shortly</span>";

                        feedback.empty();
                        if (document.getElementById("add-to-bag-extra")) {
                            $("#TopAddMessage1-b").empty();
                        }
                        feedback.html(fb_msg);
                        if (document.getElementById("add-to-bag-extra")) {
                            $("#TopAddMessage1-b").html(fb_msg);
                        }
                        console.log("global add to bag failed");

                        hideSpinner(bttn_el);
                        if (document.getElementById("add-to-bag-extra")) {
                            console.log("extra button found");
                            hideSpinner("#add-to-bag-extra");
                            $("#TopAddMessage1-b").text($("#add-to-basket-message").text());
                        }
                    });
            },


            // init procedure functions
            initPDP = function ($feedback_elmnt, checkout_bttn, callback) {

                if (checkout_bttn === true) {
                    chkout = true;
                }

                feedback = $feedback_elmnt;

                pdp_qtys();
                // init procedures

                // clear the feedback
                feedback.empty();
                if (document.getElementById("add-to-bag-extra")) {
                    $("#TopAddMessage1-b").empty();
                }

                // process Qtys
                processQtys();
                console.log(chkout);

                if ((!add_to_bag_data.apibasket || /undefined/.test(add_to_bag_data.apibasket) || add_to_bag_data.apibasket.indexOf(",") === 0) && chkout === false) {
                    feedback.html("<span class=\"error-msg\">Please select an item to add to your shopping bag</span>");
                    if (document.getElementById("TopAddMessage1-b")) {
                        $("#TopAddMessage1-b").html($("#add-to-basket-message").html());
                    }
                    return null;
                }
                else if ((!add_to_bag_data.apibasket || /undefined/.test(add_to_bag_data.apibasket) || add_to_bag_data.apibasket.indexOf(",") === 0) && chkout === true) {
                    window.location.assign("/shopping-bag/");
                }
                else {
                    // do post to API
                    postRequest("#bttn-pdp-add-to-bag", callback);

                    showSpinner("#bttn-pdp-add-to-bag");
                    if (document.getElementById("add-to-bag-extra")) {
                        showSpinner("#add-to-bag-extra");
                    }
                }

            },

            initDPW = function ($feedback_elmnt, callback) {
                feedback = $feedback_elmnt;

                dpw_qtys();

                // clear the feedback
                feedback.empty();

                processQtys();

                if (!add_to_bag_data.apibasket || /undefined/.test(add_to_bag_data.apibasket)) {
                    feedback.html("<span class=\"error-msg\">Please select an item to add to your shopping bag</span>");
                    return null;
                }
                else {
                    // do post to API
                    postRequest("#bttn-pop-up-add-to-bag", callback);

                    showSpinner("#bttn-pop-up-add-to-bag");
                }


            };

        return {
            pdp : initPDP,
            feature : initDPW
        }
    }());

    // API
    return {
        addToBag : globalAddToBag
    }
}());


/**
*
* @class spinbox
* @for Plugins
* @param {Object} $spinbox - jquery selector objects of the spinboxes
* @param {Object} config - optional object to configure properties
* @constructor
*/

/**
*
* Usage:

     $(".twc-spinbox").spinbox(
        {
            max:20,
            callback: function(){},
            min:1
        }
    );
*
*/

        !function(root, factory) {

            if (typeof define === 'function' && define.amd) {
                define(['jquery'], factory);
            } else {
                factory(root.jQuery);
            }

        }(this, function ($) {

            "use strict";



            var defaults = {
                /**
                * Max value for spinbox
                * @property max
                * @type Number
                * @default 99
                */
                max      : 99,
                /**
                * Min value for spinbox
                * @property min
                * @type Number
                * @default 99
                */
                min      : 0,
                initial  : 0,
                /**
                * Function that runs on change of the input quantity value
                * @property callback
                * @type Function
                * @default null
                */
                callback : null
            };

            /**
            *
            * @method Constr
            * @param {Object} $spinbox - jquery object
            * @param {Object} config - optional config object takes max, min, callback function to run on change.
            */

            var Constr = function ($spinbox, config) { //alert('I am invoked');

                    this.spinbox  = $spinbox;
                    this.settings = $.extend({}, defaults, config);
                    this.initialise();

                };


            /**
            * @method qtyUpDown
            * @param {Number} direction
            * @param {Objecty} input DOM element
            */

            Constr.prototype.qtyUpDown = function (direction, input) {

                var change = parseInt($(input).val(), 10) + direction;

                this.setArrowStatus(change);
                this.$spinBoxQty.trigger("change");

            };

            /**
            * @method qtyUpDown
            * @param {Number} direction
            * @param {Objecty} input DOM element
            */

            Constr.prototype.setArrowStatus = function (value) {

                if (value >= this.settings.min && value <= this.settings.max) {

                    this.$spinBoxQty.val(value);
                    $(".twc-spinbox-inactive", $(this.spinbox)).removeClass("twc-spinbox-inactive");
                }

                if ( value >= this.settings.max ) {

                    this.$decrementButton.removeClass("twc-spinbox-inactive");
                    this.$incrementButton.addClass("twc-spinbox-inactive");
                    this.$spinBoxQty.val(this.settings.max);

                } else if ( value <= this.settings.min ) {

                    this.$decrementButton.addClass("twc-spinbox-inactive");
                    this.$incrementButton.removeClass("twc-spinbox-inactive");
                    this.$spinBoxQty.val(this.settings.min);

                }

            };

            /**
            * handles click events of the spinbox calls the qtyUpDown function with the required arguments.
            * @method clickHandler
            * @param {Event}
            */

            Constr.prototype.clickHandler = function (event) {

                event.preventDefault();

                var element = event.target || e.srcElement,
                    clicked = ( element.nodeType === 3 ) ? element.parentNode.nodeName.toLowerCase() : element.nodeName.toLowerCase(),
                    direction;

                if ( this.$spinBoxQty.is(":disabled") || $(element).hasClass("twc-spinbox-inactive") ) {
                    return
                }

                if ( clicked === "button" ) {

                    direction = ( $(element).hasClass("twc-spinbox-minus") ) ? -1 : ( $(element).hasClass("twc-spinbox-plus") ) ? 1 : false;

                    this.qtyUpDown( direction, this.$spinBoxQty);

                    // event is handled
                    event.stopPropagation();

                } else if (clicked === "input" ) {
                    // event is handled
                    event.stopPropagation();
                }

            };

            /**
            * handles keypress on the quantity input box, restricts to only numeric input and length of 2
            * @method spinBoxKeyPress
            * @param {Event}
            */

            Constr.prototype.spinBoxKeyPress = function (event) {

                var keyCode = event.keyCode || event.which;

                if ( keyCode < 48 || keyCode > 57 ) {
                    event.preventDefault();
                }
                else if ( $(this).val().length >= 2 ) {
                    $(this).val("");
                }
            };

            /**
            * handles keypress on the quantity input box, restricts to only numeric input and length of 2
            * @method spinBoxKeyPress
            * @param {Event}
            */

            Constr.prototype.spinBoxInputBlur = function (event) {

                if ( parseInt(this.$spinBoxQty.val(), 10) > this.settings.max ) {
                    $spinBoxQty.val(this.settings.max);
                }

            };

            /**
            * Event handler for the on change event of the input, fires a callback if one is provided.
            * Context of thie callback is set to be the plugin itself.
            * @method spinboxOnChange
            * @param {Event} event
            */

            Constr.prototype.spinboxOnChange = function (event) {

                this.setArrowStatus.call(this, parseInt(this.$spinBoxQty.val(),10));

                if ( typeof this.settings.callback === typeof Function ) {

                    this.settings.callback.call(this);

                }
            };

            /**
            * Event handler for the on change event of the input, fires a callback if one is provided.
            * Context of thie callback is set to be the plugin itself.
            * @method spinboxOnChange
            */

            Constr.prototype.initialise = function () {

                this.$spinBoxQty = $(".twc-spinbox-quantity", $(this.spinbox));

                this.$incrementButton = $(".twc-spinbox-plus",  $(this.spinbox));
                this.$decrementButton = $(".twc-spinbox-minus", $(this.spinbox));

                $(this.spinbox).on("click", $.proxy(this.clickHandler, this));
                this.$spinBoxQty.on("blur", $.proxy(this.spinBoxInputBlur, this));
                this.$spinBoxQty.on("keypress", this.spinBoxKeyPress);
                this.$spinBoxQty.on("change", $.proxy(this.spinboxOnChange, this));

                this.$spinBoxQty.on("keyup", function(){

                    $(this).trigger("change");
                });

                //this.$spinBoxQty.val(this.settings.initial);

                if ( parseInt(this.$spinBoxQty.val(), 10) <= this.settings.min ) {

                    this.$decrementButton.addClass("twc-spinbox-inactive");

                }

            };

            $.fn.spinbox = function (config) {
                return this.each(function () {
                    if (!$.data(this, "plugin_spinbox")) {
                        $.data(this, "plugin_spinbox",
                        new Constr(this, config));
                    }
                });
            };

        });
/* End TWC custom spinbox */


// Custom build for the Hybris project
// gmarasco@thewhitecompany.com

// App wide events to ease the interaction witin the Hybris platform
// Attaching these to the topmost page level 'document'
// TODO: if it turns out these are needed on other pages, define these in the twc.global.js
twc.events = (function(){

    var onAddToCartSuccess = function(data) {
        $( document ).trigger( "addToCartSuccess", data );
    },
        onAmplienceQuickViewRequest = function( data ) {
        $( document ).trigger( "amplienceQuickViewRequest", [ data ] );
    };

    return {
        onAddToCartSuccess          : onAddToCartSuccess,
        onAmplienceQuickViewRequest : onAmplienceQuickViewRequest
    };

})();

// End Custom Hybris

/* Project About Properties */
twc.version = "2.9";

twc.about = "The White Company JavaScript Library - Recode v" + twc.version;

//Method to accept only numbers
$('.Number').keypress(function (event) {
    var keycode = event.which;
    if (!(event.shiftKey == false && (keycode == 46 || keycode == 8 || keycode == 37 || keycode == 39 || (keycode >= 48 && keycode <= 57)))) {
        event.preventDefault();
    }
});
